<template>
  <div>
    <app-main ref="main">
      <!-- 顶部广告 -->
      <template v-slot:main-top>
        <div  class="ad" ref="ad">
          <!-- <img v-if="mineKey == '1459435534555418624'" src="../../../assets/images/mall/add2.jpeg" /> -->
          <img v-if="isMain" @click="toPromotion" src="../../../assets/images/mall/acccc.jpg" />
          <img @click="adClick" v-else src="../../../assets/images/mall/adddd.png" />
        </div>
      </template>
      <!-- 主要内容 -->
      <template v-slot:main-content>
        <!-- Step1 -->
        <div class="step">
          <p class="stepTitle">Step1：选择数据来源平台</p>
          <div class="step-body">
            <div @click="stepOneItemClick(index)" v-for="(item, index) in stepOne" :key="index" class="step-body-item" :class="{ 'active': stepOneActive == index }">
              <img v-if="index == 0" class="logImg" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAC6UExURUdwTP9eAP9tAP9eAP9dAP9dAP9eAP9eAP9dAP9eAP9eAP9mAP9eAP9eAP9jAP9eAP9gAP9fAP//AP9dAP9eAP9eAP9dAP+bAP9dAP9eAP9dAP+AAP9fAP9dAP9xAP9dAP9fAP9eAP9dAP9eAP9eAP9hAP9eAP9dAP9eAP9eAP9gAP9eAP9eAP9eAP9hAP9kAP9mAP9eAP9dAP9dAP9eAP9dAP9dAP9eAP9fAP9eAP9fAP9eAP9eAP9dAOHBIkkAAAA9dFJOUwD4CaOf/FCtqmr6DXjLGvEvOgHEfKj1AuFWuwRE3AXSNJXq7pAf2LPmcCm/jYEkFRFlnEp0pIW4QLBhilsqcaZZAAADn0lEQVRYw+1X2XaiQBBFElCMgoIqEkUjivsWNa78/28N9FrQzTjJmTNnHrxP3XRxqa4dRXniiSf+MXQvKIRfb3R7WNXff0Lz1owQ3Dre+0EUWUVj/W2iz4ggMLF+ZNu7fY9nHzFc0IMT3S6B1La279x3xlU/r9s5RE1OpG3i/ZzuWslOsdf66hK2uFDUqo66Mhv2gUxipQ+6aSjqebWAFBzBaiMQVcH5QFHMAlVv6RSifFiGnWfrKCqoQCFBif5ksqgOgUXVNFGtzI4+FGVclnC4R6NG3mrXl0xPz08zNehBqKZMT7S8XM20/MCVuTX5yAF/4zRWlG7GEEddFd1jUgdo88zJ+uY5Rz1eqL00Uet0qEkc/QVsIceraJ+FRGxLD3s5PFcqUG52iPraQCY4pYJv0HbOmKy61B83U3lhUSmDAwKPwu9HVgfzUBvGyVony4ktJSpSIj1juI/ENyMNHxZtRQ1p0L2KMBSlRIkOPBzx29XkejUPWVcFbpGhCYiW4GIYU+TmfT9yYp669qdEL5Rox2PvjILzHvvhrRf9KZHHotqwWC7syTMbm1L7qlR4ZVhVGHRAVOXG3hxZ8Oxh3GqJK18iWcAAohA+PVMXtZCdxgXG85homnrsV0gEOehm9YDyPCayMgE2JsbA2bwOyyTQHhK1hN6Gg36XpIxhNEoGBjf2zGA4A6JCTo1ZwTqXh09AVBbT54K++10iTSRCRb/zF4iKtK91ihwubxn8ofEbr8XWbpF2lILgNb87T3ltKBCNUpkjJ9rem1aSaYDIzb6B8z2uLvawjLESiEwkU97kpkji/CmNR5MFjqhRjxVfWdImUHHg9ZPiRkUkuYa7udsGRKcUz/uE180BFdmLRDqr02JhQ1lKuhm6/SBfI91lxawkbdp0/nhF5QmEHSTa6gu2XnOiStbxvJGzvr5rQyIwzkQjTnQVeXCAwHFkWhz1M5MJmZTUZsqSyD58riKThZ6fZN44wIsduyadeNp8aihSFzo5NCHz1nAWZDLEL3E5Nr6YQwmL5uk26V6Lu8+0LpFE9bjkBMyCGcvEU9KMXGEcjOZwiuqS+cpJD8as2XVKLrJreVqdjHYDUBOS5YZ9P6Qjhn0d5o5T735qwj9fGt0tUqrCipQGvr79TOmYjxvSwHFccOX07FTvi0ksQVV0QHYGa88sOC/l/IoJ84krecdc2o+Iutmgmqk//Mk09cbR6VlWMHSrx1nt+df9xH+LXxPRoMKH8h4SAAAAAElFTkSuQmCC" />
              <img v-if="index == 1" class="logImg" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAAAXNSR0IArs4c6QAADlVJREFUeF7tnQeQFFUax3+9gGCAFRVBXEVRJCyciiDJU1FYUBHBO1DBhHggnJ7sgBRSZ7w69RBmENMBIlcqJjgTYgA9A1kJShYFJAh6GOBMILB99U0zO2Fndrp7ume6d95X1TVQ+973vvB/r1/43tcaivLaAlpea6+UxzEA6MNoTnUac4BCtIOPTi1lYwcsoLEHnd3hpxq72c9GbTxrHeCcGQD0Utqg0RX4I9DaCYEUD9MWWAbMQGeOFmKJ6VoJBW2NAPowOlBAKdDHbsOqnqMWmE4ZIW08C61ytQQAfSRF7COAFna+Iq9ZQCdEDYLaGLaZFc00APRSeqPxIHCKWeaqXE4ssAGd27QQL5tp3RQA9ABDgMfMMFRlPGOBoVqQx9NJkxYAeoC7gLvTMVJ/96QF7tGClfuuUgDow+mKzmxPqqaEMmcBjRJtHHNSFU4JAP1W2lGNReZaUaU8bYEDtNceYnEyGZMCIDzb3x9GTTNPK6aEM2uBdVSna7LVQXIAlBJUSz2ztvVJOZ2QFiKQKG0FABzc5FngE7WUmFYsUEbHxM2iigAI8KLa4bNiVV+Vna4F6RsrcRwA9AAdgfm+UkkJa9UCnbQg5SN8PABKuR+NUVY5qvI+soDOA1qI2yMSJ44Aq4BiH6mjRLVugdVakJYVAKCPoCVlrLTOT9XwnQUKaKWNRTp7NB5AH8EllPG675RRAlu3QAE9tLHMigdAKf3QmGadm6rhOwvo9NdCPBsPAHXi5zs/ZiBw+Ulh+SRQH84odO7PgKmq6hcLaNyujeOBxBFAjnzl6FdR1bdA+TFxdAQIhM+NFQCqvvNFQwWA/PBzSi0VABQAjEgh9QrITySoESA//V6utQKAAoB6BeQzBtQIkM/eV8vAPPe+AoACgHoF5DkGFAAUANQqIJ8xoEaAfPa+mgTmufcVAFIB4JhT4ZgmIL/1Dv7WODRa+rdf4Ofv4Jdv4Yct8OV82LYcyvb7DVJ5/gqoeQQc3xoatYeTO0L9YsPpdujXXbBpLiycBGt8E1ObZwCodxo06gBFZ0JRGzi5kx1Xp6+zZqZfgJAHAGjUDpp0gdO6wCnnp3eekyU+ehJeGOgkR6d5VVEANOtuOFwc3/B0Z4y2eRGsewvOvgHqnmie58/fwjP9YH3K5BzmeTlfsgoB4KiT4PQ+xnNCW2dNJZO+af1g1asGXwHYWVdDcU+oWdtcW89eC0ufNlc2e6WqAACaXxx1/CGHu2e6H782evIX70XbOLQunHEFFF8KIkc6Gl0H9v6YrlQ2/+5jALQbCB0GO9/bKzP/zvUwrT9sTZKRtckF0OZaaHNdag7zH4WXbs6mg9O15UMAtO4HHYe6N4NPNNl3G0De/18ugE0LYPsnlRtV5hwCgrbXwmFHVyz73HWw5Kl0jsnW330EgFa9DcfL5M4tEmdvX2H0cNncEacf2GevtSOL4JxboPPI+PqLJsH0wfZ4Ol/LBwAoag1d74SWlzmrfsTZ4vDty2HTfJAZu9PUfhD0mRjluv4dmCiJ1T1BHgdA59ug6x3mZ9qV2XTTPFj/Luz41OjlAoBsUekSKDrLaO27jXCfZ9IsexQAJ3WCkjugabfMXCQ7ctLj5PlmTWa8MqnddzK0uzHKYXjazLyZtGalrgcBID2+5E4oqG5FkWjZT16AtbMMp/9vhz0eTte6LATnDjO4fvY2TOrudAt2+XkIAMc2hV4ToGmJdWWWPgPi+M/fgX17rNd3u8bw5dDwDKOV1wLwQcjtFs3y9wgAZEftD49DYUOzgsPH/4LFTxiTNy/TmVfB1eEkHAaNKc7t6yjeVh4AgCyTevzDnAsXTQZ5tn5srnyuS9WsAzfPhYa/MyTZvBgmtM+1VLHt5xgAV0wxDlfM0mOdYcP7ZkvnvtxFf4cuo6NyeO88IIcAGPIfOLWzNSeJ8wUEfiCJO5DeX1DNkFaCRKZc6jXJcwSAG16BYhsbOz9+A3c38JoRk8sz4JX4zat/doHP3/Wa7DkAQL+njaNUOyTr+ik9rdes3yK7E6/u9xobWBHy1vZvDucAiRsiVl0pQ6jdeLv+z8BHU93vhXI8fM3zUc327IYJHeAbRz7wadVi6cpncQTIpOeLGm/fA7Mz+GbVie3g1kWw7FnjSNcNalAMg96GwuOj3DOV2w05ozyzBICrnoI219hXJZMhVCZhsgsnARtLnoYrp4Jbs/FBb8VvXy9/zggi8S5lAQDnBaDnOPsmeH6AseljhyRA4/d/AQnEkOFf6Jrn4Iwrwen9+L5PgASpRGjbUph8Mfz0XzuSZ6tOUgA4931AWeYNnhNdCllVS4bPjR/AxrnmL100udAIFjn5HFj7JnyYZNu17fX2QZVMh4vvgwvLU+/D3p9g8kUgJ5DeJhcBcFhdGDQbTmhjzQTffwkS4JlIWxYbQBCj7v/NOCKWix3h39rG5Y6jG8Pq14wzATkMygadVwo9g/EtvXgjLJ6SjdYzbcNFANid8UeG5iPqGTd1GrSI/qZSd/VMWDMLdn6WqUGs1ZflrExuY+n9sTDzNmt8clfaJQB0+jNc/og9tZx+N9uTIn0tiVW44VWoXjNadv1smJhhDEP6lp0s4QIAJJhj8Gw45DB7gvoBAHKfUJwvcX8Rkl3KSSVGtJF/yAUAiPNPyyDmzesAqHMcDJwZDfGKONutpaW7YHIYAOfcDL0fzkxkrwNAer7EL/j3vR8ruYMAOPIEuGUeHGnh3lwiVDYvhAnyyUKPkgStdLwpXji5Lja1l0cFTiuWgwCQni8jgF2a9wjMHAH799rl4G69rn+F7n+Lb2PjhzC1N/zyvbttm+EuMZT1mxuvJvMbZw4BQJZsozfYC9+WMOk3RhsxfV4lCVqR4JVY+noVPNkru+Hlse3XbWTcSZQJqWy4zZsAcydA2QErVnQIAJ2GwuWPWmnYKCtOF+cLCLxKstyTSV+1GlEJd283hv1sh6YdWggtehqOl0dGy7kPG87/aacdCzoEgJveAdmCtUKvj4T3HrRSI/tlj2sFA1+DujE7k/t+NZz/2ezsySPOjji+dn2jXTnfkB4vF1btkwMAkOH/HgsHHru2wIwhsPYN+2Jnq6Y4v0VCGFcmh1NW5G58brSn12sarSnH2fMeNi6sZk4OAKBlLxjwsjlRJEvG9EEg+/1epwtGwSUJX8+TyZUAwC069QJjJJULsCeeHd+KrDYWToR1bzrZugMAkLN2ufmSjr5eDY+e640ZczpZpfcNeTf+dpIcQj3RAyTCxynSCqBVLyOGQBx/dJI7g9LjJdeQO/GEDgAg9tpTZYaZdjUs88kXaRMDOkWv8Wc7M+mrVQda9jYCRsXp8v9EknyD4nSJYXBmqE/lGQcAIMO/vAbSkdd3+CLyy5JKQtZjaccKGGsz2ZRskDVoCRIuJrmFKpssS65BcfrHT8KO8Ee93SYHACDLP1kGpiO/ACBZ+JqZ+wiyAyrxCMeJs2MeWbqlo+83gdxvFOfLv7NHDgBAcu8NjUmclEp4b12KTC6lBK8MS3HtTKKTJN5g/x44qrHh7NjHzm3mVa/Ain8bjywvs08OAECEHrECZM1cGe3aBlMvg23Lsq+m2RZL7oJuGUQem2lnx0pY8RKsnJGtYb4yqRwCQMnd0M3E54YP/GZkyZILnk5SrUIj/atsi8qQu32lcQ/fako2GcncyCYqvTvS06XXe4ccAoAoZCUE7Nsv4KtPjIxbkQxcZobAZFm8JeevxAZKCLYsmTJZLklKmh5jnHHPzzuNuMQNHxi7htl9t5vVwUEASPy9BIPIZoYd+mp56jV2YVHyLN7bPzXOE8TxP2y202p8HQnvkth+u6OAgFqyk4jT5ZERz9vkIABEUTmh6vWQ8xm9Yo0oTt/ykdGrVsxw3rySUVySOrT/U/wNn1QtyVU1eWSX08uHWsnldxgAkUZkLd12QGa3gSK8pFfJMkzCwsXx2TTyEccaiaHlkWWepoFMZuXZvdX49Te5BICIUWRZJRm7m3UzN6zu/gp2bTXmBTKESqJGb9+s8bf7wWUAxJqndgOQpI+SPvXwY4xwanG2nA7Kr3x6RS/zu0H9Jn8WAeA30+SHvAoA+eHnlFoqACgAVPxyqHO3g/Pcuj5QX40APnCSmyIqALhpXR/wVgDwgZPcFFEBwE3r+oC3AoAPnOSmiAoAblrXB7wVAHzgJDdFVABw07o+4K0A4AMnuSmiAoCb1vUB7yQAGM4odBIuxflAFSWidQto3K6N4wGpWP4dMz3AEOAx69xUDR9aYKgW5PF4AJTSDw2fXOLzocm9JLJOfy1E+ItW0RFgBJdQxuteklPJ4pIFCuihjWVWPACG0ZwCcviZTZeUVWwrWqCMFtp4wl+yiPuWqR5gKdBa2axKW2CZFuTgB40rAkByn99XpdVXyo3WgtHVXvwIUEobNHzydUblSVsW0GmrhVgSqVvhc9Z6gBeBPraYq0pet8B0LUjfWCErAmAYHShggdc1UfLZsEAZHbXxLKwUAPJHvZQgGqU2mlBVvGoBnZAWIpAoXoURIAyAkRSxH/lYb5L0VV7VUMlViQU2UJ3ztTFUuNSYFAAHR4HeaLykzFoFLKBzuRYiaVLHlAAIg0CdD1QB71O+759MmUoBcBAE6sKIf2FQfuybSoW0AAiDYDhd0clilmT/WtwzkmuUaOOYk04eUwAIg+BW2lEN+ZRns3RM1d9zaoF1HOB67SEWm5HCNADKVwf7CKglohnT5qCMTogaBJPN9jN6BSRW1o3NItknUDuGOfBzkianU0YocZPHjGiWRoAKQAjQEZ1L0ZDk+sVmGlRlHLPAanRmojFTC9rfuc0IALGq6CNoCTTiAIVoBx+dWo6p6x4j3T3WDnHW2IvO7vBTDclbv1kbiyNZpR0DgEOqKjZZtoACQJYN7rXm/g/nNde9mk1wPwAAAABJRU5ErkJggg==" />
              <img v-if="index == 2" class="logImg" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAADJUExURUdwTNwAAMgAAMgAAMoAAMgAAM8AAP8AANUAAMgAAMoAAMgAAMgAAMgAAMcAAMkAAMgAAMgAAMkAAMkAAMgAAMwAAMgAAMgAAMgAAMoAANIAANAAAMkAAMgAAMgAAMoAAMoAAMoAAMgAAMsAAMgAAMgAAMgAAMcAAMgAAMoAAMgAAMgAAMgAAMkAAMgAAMoAAMgAAMgAAM0AAMgAAMkAAMgAAMgAAMgAAMgAAMgAAMgAAMgAAMkAAMoAAMgAAMkAAMsAAMoAAMcAAMCwlJwAAABCdFJOUwAF9vk75hUBCto1z5vW/HXGkWhJ7R7D8ckhEg9toas/MDm/JE7+6dKNJrTgpV3jHMy4GYhjen1ScZeDrmBEu1csKTt9cKkAAAKpSURBVBgZ7cDXVuJQAAXQEyCN0EtCryK9dxV1zv9/1NACCaJyw6w1Prjx69f/kMtWAsmHrU2wrsELrVyId8I+Oj2a8aUGAdn+2ojwg3DrbRMc4kZaMq7zGqOM2ymJUIrX6RqO6mt8TUnUIj088LpwDjtSsuhP4Qtafxwh+YAqP+E3xp3MIELyGU5/EgGclIsW9wJ44bfKcFAssrnEjhLVaQtVmvxOB0597ozrCBb9FJKawGnNPV+GghpJOGkWPYrCJUGP4nBr0gv5da7CpcpPhJ4avCJllKYvgTw0XCjyINygW1nNbwqt3tgcGcbIfH0OtaL9zXteVYJv81BNLsBN8fOgGKVb93EQKiQraSWvTLLtymaZmLdKZtfPvVcVblEeGZj5eDNZgZuq80gH6jXeyF/FhSRtMWz1Zd7kBZeeaVtjR3vy8XtTXBpGaCvjIF2M8BslFZeeaOvgpL728SsxDR+EeTTKw0F7qTX4GT2Hj3ILnVv6SsKF9DzMq+Q0rptUq0NcVZkO+EHqHR6ogbhMFysIj9TyWuZJKoA7qNVpM8ItvZXDvaR29V3Bz1EO4J8YPrJbG5u6D/eRMjywcJ8Qj1K4S4K2Ae5R9dOm4w4TmSdheCfFeGbAuzUdRvBsRqcMBNVVHAT9dIpB0EzFnjKgiwlBC+xJJt1MCIpjL84LJgQ91bGV4Jm8nMikCUHBkoZ2kWeZHLAgYxAVtR7pYOQBtMkRhGVnhRJt1hA7OpvwQJNJi7Qi5Ap7cerwYEV20112yLCEvSS7ECfJtNoocU4WcKD5LYibsZEEiqk3+vI4qjVUCGtyCqDXW7EHW5R5iNowIwEw31pcwvaHdYh69tWxJadLPg0n4TIEpSMFbKkyzA7OCgkIWtRU7CxgrHAmVSAomMVRIIdfP8lfDbtcExqqJ0IAAAAASUVORK5CYII=" />
              <img v-if="index == 3" class="logImg" src="data:image/png;base64,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" />
              <img v-if="index == 4" class="logImg" src="data:image/png;base64,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" />
              <img v-if="index == 5" class="logImg" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAAAXNSR0IArs4c6QAAFUtJREFUeF7tXQuYVMWV/v/bDKMEH6BoTFyjJhoRRaDvQHyQAGpWY9ZEfITEmPj5QXej4UNdUTcJK2ZNsvGdKNK3QU00btxgNlE3upjXJCrjTN8GxMcKQowbBXyiDCKPmXv2qzvDY2a6+z667u3ugfq+/ka5p845deq/p+pWnTpF1FGRy5pGoAPHAc7hAA8HsOvvAwBrAKwFpPuv0YIBXMy5be/UUTNjVZWxSgsoTObAwNqmiQBOB+QcAEcHZLGdvAXAUwDaaNkPheTRL6vVJAAkbZ4O8kI4cjqIj2m1vKAAIMecndPKt06Z1RQA5NKmf0CHXA3iW5Hbcw8QXBPXDAAkY34LglkADou883sKeAKGM4vzliyPWW5NiKs6ACQ91gScH3SN81Urb8DBLM6376+aBlUSXFUASLppMiB3ATi4Su3vJVZuplVQXmi3KVUDgGTMSyC4u+YsTS5kNn9BzekVkUJVAYBkzCsguDWiNlXOdjcCQewAkJR5HYg5lfdSxBx2ExDECgCZ1jQChjwfcdfpY78bgCA2AEgq2QDyTQD76+uhODjJtbQKP4pDUjVkxAeAdHIuwEur0cgKZXaCOI1Zu7lCPjVZPRYASLppJiC316QF/CglWIytg0/lT5s3+yGvJ5rIASAZczQES+rJKCV0vZWW/c/9oB09mhA9ANLmnQAu6weG64ThjNG1ZCxzjh2INXt/GkADGp2/846lb1XDRpECQFLJY0Cqt3/vmBrXDOJxEC8BWMF59gpJjzsW0jEC4AgQZwMYHV4X+TGtwuVh6ss082wQanfzaECO7o5n2JXVFgCvAfg76PwM2xof4d0t74aRFaROtABIJ28CeFUQhULQboLgJjDxS1qtL3rVd7eaBVNAXOJFW+T5BoiMYa6w2k9dSSVPAY0vQuQSEMP81OlJIw+AxuPM5h8IXtdfjcgAIJeN/gQ6EurtH+pPlRBUggdh4EZm7aVBa8t082w4uBrAyYHqEj9g1v5OuTrdexzXABgbiHdp4hbQmcvsEu1AiA4AqeT3QM7WZIC+bATXM2dXvKIoGfMxCM4MoOdaDDCOLxZmJqnkITCM2RCZHoBfENInAN5JK/9okErlaKMDQNpU47Ca5Ogvmjp/u2KSNp8BMC6Aot+kZd+3K71kzIsgMhvgUQH4hCOlzGS28JNwlXvWigQAMn3MeDjGX3Qo2IeH4Dbm7Ct185a02erbZfdaIpaU+W0Q39etU1l+ml6CaAAQnftvwaCGU3lby4e6jS1XnLg3NnW8DMjHffD+EAM6h3Pu0lerusilAQTRACBjPg3BST4MGYyEzqnMLvljsEr+qSUzZhLE+IO/GrwM7NwEMe71Rx8RFTGxkmVq7QCQVPJAkFEsauRo2emIzLiDraTMX4CY4kPObwGc5YMuehLH+DTnt60MI0g/ANJNXwdEf2yd4Zict0SFdEdaJG1+CcBvIhWin3kztjWezXuebg/KWj8AUuaPQPf7WmeJ5e3frrBkzDYImnQ2IAZeoWwUBQDuDrnKVtpGIucwV4jtrZRM0w8hcm0MnaZENEPwZxhoVmO5u3oInAKy6y+wn289QnhJ/QBIm6qjlBvVVd6jZQ/RxcwPH8mYEyD4kx/aCmhWALycVv5/SvGQaWOPhuFkAajjcX5KYC8QBQDUGbxgy6vlmlalsCxJm2sBfNSP1UPQPKxWC5krKBlli8yZMABrNt4D4iIvWvd5QC8QBQD0rgAS1zBr3+ir8RqJQiwR+5Me8ttdUuYcENf5EDKXlu37aF0UAFCfgAf6UNQficg05goL/BHro5J08ucAL9TH0eX0AgYmTuIdrRuC8pXzz09g6Ct/9vaufJ1W/lC//KMAgPgV7o+O59LK/5c/Wn1UkjbVWvsMfRxdTlNp2aEPw0i66QxAHvfUSeQC5goLPemiOBwqaVOvB6hwpcuPEYrR6D+/wEW08meE1Wd7PUmbtwAovxcSYN4UhQfQOwdAP/EARIZZ26oYAKnkGJCeC2K0bF9964soiNKSNvV+BfSbOYDRRKvNDmLLop5pxpmN2PLWBhADy/La1rivn5XBKACgdx2gf3wFvEvLPqDSzt9lGHgOULmSyhRuO5TZZ1/3kqkfAClT80qgPECr8HWvhuh+LunkawD9bA17iyZ+z6ytLf+BZMyHIDi3rGCR4cwV1HBcHideBEGfi/69AK1vj5/2SCo5DqSKEtJTBHOYs6/XwwzwNUElxjFrt3nJjMADJL8GUm/wooMvcL7t/fnj1VqfzwMsuvjkiMdo2dq2jiVtPgjgKx4eYDxzBTUfi9kDZEYeBBn4hpfggM8Dr3EH5N+DPILdwLdp2SHCwou3QtLJZQBPKNtGwznBzyEW7R5AKaX9S0AxDbjGHRYA0cUDGKNotT0bVq/t9WTGpxqxdf/3ATSWf7U7jmB22d+85EUDgEyTCo3+npfwgM9j8QIBIoKCqU+mmM3PD1apL7VMaxoFQ7zPQXQ0HODnZFE0AEglJ4LUH7sXdUxgtNFAWuYBvifZKwY3sLm5wwtw0QBAbWGu2/gqRHOWTyC6qOBUcj+Qf430JBM4hVb+P706pdRzyZgnQ9yUt17lKVr2eC8i9TwSAHTPA9SyZ8qPEoFoojsXsArAJwPpEpSYfJLZ/GeDVtsx/vsOtuEsWvmb/ciJDgDTxyThGBUvfZZohLaz+t2pa54AMMGPwSqmCTkXCJRWz+FYzs/n/egaGQAi9QJdLbsPAxMzwuyt73yjxp4AOCpzSTydv10w+S/M5v/dTwd12TE5A6Dfo2Av0bKH++UdLQCi9QKqjTbofJfZJYv8Nnhn5yczAG8AoG2NPqAOP0dn4iouaC27ZiKppptBCZCZhDfQyvs+lBspAGLwAl02F1yPhPOon3MDMs08Ewl+BSLfDNhh+skFy0E8A8jzELQxV2gV9dJ0GsmuhBai3uQgewgbYHA05+XVZNZXiR4A0XuBXRvaCsGjMPA24P7egSPDQGMYRA4CcCGIT/myTD0SCX/CXH5mENUjB4D7gqaSs0HqXhgK0s7dg9bhaM7PLwvS2FgA0D0UqHH680GU20MbwALElczatwWo4ZLGBwAVybL1LZX0aFBQJffQe1rgblr2VE+qIgSxAaDLCzSdCsjvwyi6p05JC7RgYOKMsJ/DsQKgaz5QJ9nC6wNxLwCJC/xkRyvVnNgB4IIgM/YciBN7rH999KlvLSvu/FjnAL2bJVHtGPq2X10Taun8qgKg+/NQxd6p8LFoN2Hquq97KU8uQKLjBpWfSEezqjIE7Kq4TB0zEglD7VwFWfHS0fZ64/EcyBuYzf9Sp+JVB8D2xlTx3kCd9tTPS6B29RYisdcCzntqvW4BNQMAd0iI8+ZQ3ZbUy28lIIsBLqRlP6aXdU9uNQWAHd6gK6GzSrCssnv3t4WjrQDaAbYDopI6bQSwBYKHAHkRA4z/5V35dVF2+q68axIAO4AwY/QwbB1wPiBfruIcYVtXh7kdtWvH7fw3sh2OtIPqZ7RDZCPotKMz0e7+NRra4WzbiMb323nHKpUWvmZKTQOgx2RxJxiOgvAgUFSc/TCAwwB3p6+hm74TgnZQdZZ6w9Sb1t157r+rfzPaAWej+1f9v9t53f8txkYY0o7NHe2Q/dr74zUxdeMBauY16ceK1I0H6Md9UNWm7QGAZvO7Wb3eeX8INjcMATuHgMYQQIYAHALKEIh8BMK9YHAviOwFQP3UlTpd/02sg6ifvAFD1kES6+BgHRqwLorJ4R4AlAGAXDxqfzQ2DkPCGYYO5yAYxjA3wsjgULdThd2d293BgMpnuI9mTPX6buNCCB5BQ8cfeefSNZXK2q0AULJD1X0+5SeWldo5qvoq3+Bs5goqYUSo0i8B4C4vG/wCwBNBHFbkSyGUsWq2kshnVEBpGP36HQB2z3iD8FlUQgFAUslBAGeBGNX1zS0rIViBhKxAJ1cxV9gUBo2V1pFpTU0wxDMrRqVyarB+My3bbz7hHuoHBkB3IuVby17AKHgVxAp1eSMEal1bXWaw2u99e2ENLOmmSwGZG7Z+HdeLBwAydewRSDi+Dx30MSjxIcQFwwrAWAlx1IHM1RhgrNLxiSOZMf8IMUpm367jDvZSPXoAyEUjP4JBA1WCwmiuggPWut6CWAVyFRxnNQyuQkNitd+AR5kxbl9s6XwGhO+zcV6WrZPnMQAgnbwdYKBTJ5qM5wB42fUUChjg75ht++9SvLtvK/8VgCM0ya8HNnEAwPROThibqWQ2rYI62Fm0SHrsiaCjcul9LDaVqisoWgBIZtThkAGvVLeNvaQLrmbOvqkkCLqCTh+KNuNHzVgkagDEcoVKcGuKzGSu9BWq7klgQwVa9Lugkp22ItaouVOkn4Ex3aETHACqhiDNnJ0r4wm+DFLNCYxwAmqqlvqCWgrBS+5ntuGsxJa9V/pJCl2qFb7WAXwCQM3gVTBG/DNwkYuZK/yszMRwCgS/qKmu9FZmKQiVDk79nocjK/zcMeTNtieFJgDIr2kVJrsvpJvIcOjxoDPSzWYpMhKQE9zt0CgL8VVmbZVCtfjEMNN0MUSqe81rcdVUyJmaYC8FxAYSto608n5NrQcAxAxm7TvLCZVU8pMgj4NgBIiR7k+3t6Axmdm2X5cEQdpNCzPPr3EioFOXXi8H+RzEWa46G9JpM1dQIKhK0QMA8HO08oGvi5fLxh6ArXIcDBcUx0FkBCDHV+AtVMDl5HKh1JIyLwcR+Bx9Bb3zHkS+DYPL4cjSau2TRDwHME6i1dZSgZF2VHUjatZuUvlxvgOR80Pw3ABwMq18yVvAJZW8FuQPQ/AOXoWcyWzeb4av4PwrrKHJA+i5DqV3W0KnbSfegiOTy6VLj2nb+FFatjrboLXIpWOGY5txAgw1v+JIIHF12CPiugCgJRN2MStVcAvZa0hwMu8qnTAx8juCafxTuWVrL1RIKnmg28mO0TVn6homhwMc3KOu4PvM2d/14lfsuSYAJEaERaCX0pI21R2+YRM5rgY6z6W1tGSadkmbaj5wuZcegZ8L3mLOVucVfBVJJY93O1sSx7jp4VRHC4eDPtL4VJA+VxcAjqbVqjZstJcKAaD0eQEi55W7P0fSpvoyyGhWfgktO9l3WEseiIQMR6cxHAaOcb+E1I/4RGj5Aos5O5T+egBAf5cThGmgBgAosUvQaZzHBW0l9zMknbwX4MVhdCxR5y+07M8VmddcB2KORjmK1X207FCJLzUBwN8VZWEarQkASnQLtnWex3tKh1JrviyihZZ9UkwAeIiWHeaLycf44ub08dgM4taDmV3+ZpgO9qqjEQBKVDMGGOdxbts7xeRKetyxQOcLXjr5ek7kmbXHxgSA39Kyv+hLr15EejyAsWUo5z2nPXmB0lUzAFRqxEVIfHAe73pRnfbtUyRtPg9gRBhj9qgjWMacPTomAPyJlj0pjM56ALDP1sG8efkHYRTwqqMfAG56zEfguBPDPkuwGuU9T8s+PiYAtNKyP+Nly2LP9QDgkE2NnPOiSnygvWjskJ66lbhhW6O8onn7I1mAEixnzi5/jVyJntEDgKxtkBDtvR/JELBDy6JRNBoBsJqW3SczeUQAWMWcfVQY++sBgMjAqHa0NHZIb/tECwDiVWbtw+MZAvg6rfyh1QNAYtM+pSZVYZTatU7dAkCwhjm7z+XTkXgAYD0te2gYW+vxAAOMA0t9WoVRql8AAHyTVv7geDwAttCyVX6BwEUPALZ1frzcAktgrXapULceACh663kvD7AB5CJAngWcZ4HEN0JugQOHDG7gHO+LInv3hR4AdBpHlltm3U0B0E7L3reIB5gDGoswKLGMt7WoCKEdxT3PAGdxKHttTOzHB1o3BK2rBwAiw8tttgRVqn8MAfiQlh0ox6FMbzoSjqwOZa/OxEe9biArxlcPANA5qtyWa6gGdVeq4yGgg5a9PXWdLxN03wy+2Rdxb6KQXlgPABIcWy7wIlSDogYAcSOz9jV9XHRl8Qc92NGyfdlXVeoKhduoNnT+I5y9wsVk+FLQczNIZHy58KtwDeqqFZEHKBmqJWlTpWE/rBKdd9Ytf4evpJKHgTwZxGkQnFaZ3HBheXoAAHyNlh3JwQv9AJCXYRhnFLtcUaIJG28G+ATYuRYO14A4EqDaJWwCcJweoKlzT8ZnOa/tyaD89ACAvIXZ/FVBhfuh1w8AnFUsbFymNZ0EQ9TVdj3j7fwoWQs0xERm7eagqugBABD6dKqXwloBIHIVc4Vb+oz7lx47GM6gRRD0CeDw0q9Gnm/GwPf2D5OIWhcAVGbso8J8hngZUBsAhAuYy08rJi+imECvpul7LniQOfurYRjqAoDaZJ9FK6+uftFaNAHgKeyz9YxiMQsRjftabeDBrCLvqw8AFexJl2ugBgC8DRhnFjtwWdfjvsoL4GA+c3ZFAab6ANDVi69B8G/4cOsDvF9PhFDFACC+wax9fz8a91V+gEcAsXQcF9cNgG47y9/UfTcQ+VXYFKbbO6wyAMiPaRWKHvqoo3FfhdrlQRYgsoiW/Tud44svACiBkjIf7r7DJ5h8wXIAf4CBR8J8poQHAJ/EwPWnF5sZ1/i4r84uPAORAgwWsLWxUEkGEK/O8g8ALUkY+TrgPAwaiyHGUj/HySRjvh4i29cHgHF6sRPLNTjut0KwGEQejlHg/DaVBia24hsArhfImLdCcIVG7VQgqRrTloHyCoTrAVkPMdaDciQMnhZqf7xMwoqIInL8muRdAE+DXAzIM1G/3X6UCgSAbhCo/Hvn+mFeJZp7admXlP+yaJoJyFkx3ESmbvtsBaQFjiyOasu8EjsHB8D0U4ZANqtVM7WWXWNFngW3fd7vKaWu/XdMduc2IuMrbMxaAK0QUXn73V+tZQMp1r7AAHC9wNQxw2EY/wpiSoVG01td5BzmCr8Jw1RSyUNUZhEQ6kTvMd2/Uomt1IGSVvftdpztnf1/YeRWu04oAOz4RMuYCgBX1og3uJ2WrXN+Apk67mAM6OyZ9s6RDcwVllS743TJrwgAO4CQNr8EwZQqeoRl2NIxkT9d9p4uw+wufLQAYAcQuu4TmARwIiDqsOIhsRiyAtcfi341LEQrAHZtp1w8YS80bpwE4STQBUOfk7Ka7KLd9WvSqy7YRAaA3q138/grr6AAAahfqIMMvfjucf0Vwiw2APTwDmrGncBEODvAEO5yhz2uv8LuVyfla6BIKnkKaIwH5BQA6nvc6/bNv0LkWuYKC2tA/bpWoSYAUGS4mAAHE0CoJEvqr9r7VgsttkruUC4VbF33RhWU/39t/Lj5ohlUwQAAAABJRU5ErkJggg==" />
              <img v-if="index == 6" class="logImg" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAACTUExURUdwTP+MIP+YKv+nN/+MIf+MLv+MIf+LJP+NIf+VKf+LIP+NIf+NIf+MIP+PJv+MIP+MIP+LIP//tf+OIv+qVf+MIf+LIP+NIP+RJv+MIP+LIP+MIP+PIv+MIP+QJv+RI/+MIP+LIf+LIP+MIP+LIf+MIP+MIP+MIP+OIP+LIP+NJP+MIP+NI/+MIf+LIv+MIv+LIPWW4WIAAAAwdFJOUwDrBwQ+CvlAcgyMNFmnIcHS2wE7A1PwZhTI5vwv4RgctGDXe6KGl6xG9Se5QU6YavicNRAAAAG+SURBVFjD7ZjrcoIwEIUFbCQBRBRRFO/XqtPu+z9d0elUIbspyaTT6dTz9+x8I7mc7NpqPfVUVZ7bV7iu24TxMtyuM4DpJN8FsjsfLZNXADaL/a4S4/oO3BUPqu5YsAc3UqC6PahKpA9u26mabEVxglplqfN9PUImuTucs5iArO3X72GI+45x+jlgGn2uj4OZU2RDWiHKAYffXIG7MQJK8FLY3PadEe5F4hREJfSu7ohy9xJoQ5XConSXlDmRQBEJOpbujHR5HRSTpddzx0j3VAf1yFK/vIGkCYMfA+WGoKIOOhiCxnWQMANlUgR2zECRHK+OESiU75pvAlqnSMzODEBDLI8Cpg3a4xEZTjVBZ48I7WOmBXrz6Gckag5KhsqXrRDrJqDsEHrfPrb8NGg/qgy2fqeiYJ7+zV6En9qVDyk/LdX/tEIkyGJz3cWmtp9rbj95ILnegaSvCNe6IopLy3UurSpGuE6MqIKNawSbMmq5RtRewAgkh78wA8nP0cEMJD+QuSGo0Goi+G90I9YaLWutn7Vm1Fp7bK1htzdCWBtqrI1Z6OC3vA9+q8aDn71R1N5wbG9ct/gHwlP/Sh9corWix7EMfwAAAABJRU5ErkJggg==">
              <span>{{item}}</span>
            </div>
          </div>
        </div>
        <!-- Step2 -->
        <div class="step">
          <div style="display: flex;align-items: center;"><p class="stepTitle">Step2：录入收件人信</p><span style="margin-left: 20px;color: red;width: 800px;margin-bottom: 24px;font-size: 22px;" v-if="isMain">绑定店铺，单个店铺每个月发货订单量超过300<br />可以联系客服，返订购软件的费用！！！！</span></div>
          <div class="step-body">
            <div @click="stepTwoItemClick(item, index)" v-for="(item, index) in stepTwo" :key="index" class="step-body-item" :class="{ 'active': stepTwoActive == index }">
              <img v-if="index == 0" class="logImg" src="../../../assets/kd/sd.png" />
              <img v-if="index == 1" class="logImg" src="../../../assets/kd/mb.png" />
              <img v-if="index == 2" class="logImg" src="../../../assets/kd/smart.png" />
              <span>{{item}}</span>
            </div>
          </div>
        </div>
        <!-- 录入收件人信息 -->
        <!-- 模板导入 -->
        <el-collapse-transition>
          <div v-if="templateImport" class="selectWay templateImport">
            <div class="upload-left">
              <el-upload
                class="upload"
                drag
                action=""
                accept=".xls, .xlsx, .csv, .xlsm, .xltx"
                :show-file-list="false"
                :http-request="uploadFile"
                multiple>
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或 <em>点击上传</em><br><span class="upload-span">仅支持CSV、XLS、XLSM、XLTX、XLSX文件</span></div>
              </el-upload>
            </div>
            <div class="upload-right">
              <p>注意事项:</p>
              <p>1.从官方平台导出的订单模板，无需任何修改，直接上传即可</p>
              <p>2.可选择下载本平台指定模板格式上传，点击 <a :href="url+'/uploads/地址模板.xlsx'">下载模板</a></p>
              <p>3.仅支持CSV、XLS、XLSM、XLTX、XLSX文件</p>
              <p>4.为不影响您的正常发货，请留意各省市快递停发区域。 <span @click="seeSending">点击查看停发区域</span></p>
            </div>
          </div>
        </el-collapse-transition>
        <!-- 店铺导入 -->
        <el-collapse-transition>
          <div v-if="storeImport" class="selectWay">
            <!-- <h4 style="color: #f66;font-size: 18px;margin: 12px 0;">目前618大促，所有平台的订单同步都会进行限流，如果您的订单同步出错或者过不来，请您稍后重试。 目前各大平台相对不限流时间为上午10点前，晚上9点后！！！！</h4> -->
            <div class="store-select">
            <span>选择店铺：</span>
            <el-select v-model="shopValue" clearable @change="shopChangeClear()" placeholder="请选择店铺">
               <el-option
                  v-for="item in shopOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
            </el-select>
            <span style="margin-left:16px;color:#1890FF;cursor:pointer" @click="jumpToStoreBind">绑定店铺</span>
            </div>
            <div class="flag-select">
              <span>标记筛选：</span>
              <el-radio-group v-model="radio">
              <el-radio :label="6">全部</el-radio>
              <el-radio :label="1"><i class="el-icon-s-flag" style="color:#ff0000;font-size:18px"></i></el-radio>
              <el-radio :label="2"><i class="el-icon-s-flag" style="color:#ebe534;font-size:18px"></i></el-radio>
              <el-radio :label="3"><i class="el-icon-s-flag" style="color:#34eb4f;font-size:18px"></i></el-radio>
              <el-radio :label="4"><i class="el-icon-s-flag" style="color:#3452eb;font-size:18px"></i></el-radio>
              <el-radio :label="5"><i class="el-icon-s-flag" style="color:#b434eb;font-size:18px"></i></el-radio>
              </el-radio-group>
            </div>
          <div class="selectWay">
          <!-- 标题 -->
          <div style="color: red;">
            <p>1.先点击同步订单之后，再进行搜索，搜索最多支持72小时内订单</p>
            <p>2.如果店铺订单过多，请先在店铺进行插旗标注，选择对应旗帜再点击同步订单</p>
            <p>3.同步订单只同步当前店铺72小时内的待发货订单</p>
            <p>4.同步订单提示授权过期的，请先订购服务，再重新授权</p>
          </div>
          <div class="list-title">
            <div><span class="span-two">共获取<span class="span-three">{{addressList.length}}</span>条数据</span></div>
            <div><el-button @click="getOrderListByStoreName">同步订单</el-button><el-button @click="nextStep" type="primary">信息正确,下一步</el-button></div>
          </div>
          <!-- 订单展示表格 -->
          <div style="margin: 10px 0;display: flex;flex-wrap: wrap;align-items: center;">
            <span>时间筛选：</span>
            <el-date-picker
              v-model="selectTimes"
              format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              range-separator="~"
              :picker-options="pickerOptions"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              size="small">
            </el-date-picker>
            <span style="margin-left: 10px;display: inline-block;">商品名称：</span>
            <el-input v-model="title" size="small" clearable style="width: 150px" placeholder="商品名称"></el-input>
            <span style="margin-left: 10px;display: inline-block;">最低价格：</span>
            <el-input v-model="minPrice" size="small" clearable oninput="value=value.replace(/[^\d\.]/g,'')" style="width: 150px" placeholder="最低价格"></el-input>
            <span style="margin-left: 10px;display: inline-block;">最高价格：</span>
            <el-input v-model="maxPrice" size="small" clearable oninput="value=value.replace(/[^\d\.]/g,'')" style="width: 150px" placeholder="最高价格"></el-input>
            <span style="margin-left: 10px;display: inline-block;">订单条数：</span>
            <el-select v-model="size" size="small" style="width: 100px;">
              <el-option label="10" value="10"></el-option>
              <el-option label="30" value="30"></el-option>
              <el-option label="50" value="50"></el-option>
              <el-option label="100" value="100"></el-option>
              <el-option label="150" value="150"></el-option>
              <el-option label="200" value="200"></el-option>
              <el-option label="300" value="300"></el-option>
              <el-option label="500" value="500"></el-option>
              <el-option label="1000" value="1000"></el-option>
              <el-option label="2000" value="2000"></el-option>
            </el-select>
            <div style="width: 100%">
              <div style="display: flex;margin-top: 8px;width: 100%;">
              <span style="margin-left: 10px;display: inline-block;">第三方平台订单号：</span>
              <el-input
                type="textarea"
                :rows="7"
                placeholder="请输入第三方平台订单号,一行一个订单号"
                v-model="ids"
                style="width: 400px;">
              </el-input>
              <span style="margin-left: 10px;display: inline-block;">排除第三方平台订单号：</span>
              <el-input
                type="textarea"
                :rows="7"
                placeholder="请输入不需要发货的平台订单号 一行一个单号"
                v-model="notIds"
                style="width: 400px;">
              </el-input>
              <el-button type="success" size="small" style="margin-left: 15px;height: 32px;" @click="searchOrderListByStoreName">搜索</el-button>
              </div>
            </div>
          </div>
          <el-table
            :header-cell-style="{background:'#fafafa'}"
            :data="addressList.slice((currentPage - 1) * pageSize, currentPage * pageSize)"
            style="width: 100%">
            <el-table-column
              label="序号"
              min-width="5%">
              <template slot-scope="scope"><span>{{scope.$index+(currentPage - 1) * pageSize + 1}}</span></template>
            </el-table-column>
            <el-table-column
              prop="order"
              label="订单编号"
              min-width="10%">
            </el-table-column>
            <el-table-column
              prop="nick"
              label="旺旺名"
              min-width="10%">
            </el-table-column>
            <el-table-column
              prop="title"
              label="商品名称"
              min-width="16%">
            </el-table-column>
            <el-table-column
              prop="payment"
              label="实付款"
              min-width="8%">
            </el-table-column>
            <el-table-column
              prop="created"
              label="下单时间"
              min-width="15%">
            </el-table-column>
            <el-table-column
              prop="name"
              label="收货人姓名"
              min-width="10%"
              >
            </el-table-column>
            <el-table-column
              prop="phone"
              label="手机号"
              min-width="10%">
            </el-table-column>
            <el-table-column
              prop="address"
              label="收货地址"
              min-width="30%">
            </el-table-column>
            <el-table-column
              label="操作"
              min-width="10%"
              >
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  @click="handleOrderListEdit(scope.$index+(currentPage - 1) * pageSize + 1, scope.row)">编辑</el-button>
                <el-button
                  size="mini"
                  type="danger"
                  @click="handleOrderListDelete(scope.$index+(currentPage - 1) * pageSize + 1, scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @current-change="handleCurrentChange"
            background
            class="addressListPage"
            layout="prev, pager, next"
            :current-page="currentPage"
            :page-size="pageSize"
            :total="addressList.length">
          </el-pagination>
        </div>
        <!--编辑表格dialog-->
          <el-dialog title="编辑收货人信息" width="30%" :visible.sync="dialogFormVisible2">
          <el-form class="editForm" :model="editObj">
            <el-form-item label="收货人姓名">
              <el-input v-model="editObj.name"></el-input>
            </el-form-item>
            <el-form-item label="手机号码">
              <el-input v-model="editObj.phone"></el-input>
            </el-form-item>
            <el-form-item label="收货地址">
              <el-input v-model="editObj.address" type="textarea"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="dialogFormVisible2 = false">取 消</el-button>
            <el-button size="small" type="primary" @click="dialogFormYes">确 定</el-button>
          </div>
        </el-dialog>
          </div>
        </el-collapse-transition>
        <!-- 手工填写 -->
        <el-collapse-transition>
          <div v-if="handWritten" class="selectWay">
            <el-tabs @tab-click="handleClick" value="first">
              <!-- 地址格式一 -->
              <el-tab-pane label="地址格式一" name="first">
                <div class="addressOne">
                  <div class="addressOne-l">
                    <el-input
                      v-if="stepOneActive == 2"
                      type="textarea"
                      class="textarea"
                      :autosize="{ minRows: 6}"
                      v-model="textareaAddressValue"
                      placeholder="真实订单号，姓名，电话，地址（中间用逗号分隔，回车键换行，一行一条~）
  真实订单号，姓名，电话，地址
  真实订单号，姓名，电话，地址
  真实订单号，姓名，电话，地址"
                      >
                    </el-input>
                    <el-input
                      v-else
                      type="textarea"
                      class="textarea"
                      :autosize="{ minRows: 6}"
                      v-model="textareaAddressValue"
                      placeholder="姓名，电话，地址（中间用逗号分隔，回车键换行，一行一条~）
  姓名，电话，地址
  姓名，电话，地址
  姓名，电话，地址"
                      >
                    </el-input>
                    <el-button v-if="stepOneActive == 2" type="primary" size="medium" @click="addAddressOneJd">确认添加</el-button>
                    <el-button v-else type="primary" size="medium" @click="addAddressOne">确认添加</el-button>
                  </div>
                  <div class="addressOne-r">
                    <p>注意事项:</p>
                    <p>1.姓名，电话，地址 按顺序填写，中间用逗号分隔，一次可以输入多个收件人信息，一个收件人信息一行输入。</p>
                    <p>2.如遇东莞市、三沙市、儋州市、嘉峪关市等没有区的城市，区域可设置为“其他区”</p>
                    <p>3.为不影响您的正常发货，请留意各省市快递停发区域。</p>
                    <p><span>4.拼多多收件人名称或收件人地址必须包含分机号 例如张三[1234]|湖北省 武汉市 江汉区 解放大道392号[1234]</span></p>
                    <p><span>5.京东明文取单：京东订单号,必须填入真实京东订单号,或者请绑定店铺密文发货</span></p>
                    <br>
                    <p>示例:</p>
                    <p v-if="stepOneActive == 2">京东真实订单号，张三，13888888888，湖北省 武汉市 江汉区 解放大道392号</p>
                    <p v-else>张三，13888888888，湖北省 武汉市 江汉区 解放大道392号</p>
                  </div>
                </div>
              </el-tab-pane>
              <!-- 地址格式二 -->
              <el-tab-pane label="地址格式二" name="second">
                <div class="addressTwo">
                  <div class="addressTwo-l">
                    <el-form :inline="true" :model="arsObj">
                      <el-form-item>
                        <el-input v-model="arsObj.order" type="text" placeholder="订单编号(可不填)" style="width: 150px;"></el-input>
                      </el-form-item>
                      <el-form-item>
                        <el-input v-model="arsObj.name" type="text" placeholder="姓名" style="width: 100px;"></el-input>
                      </el-form-item>
                      <el-form-item>
                        <el-input v-model="arsObj.phone" type="text" placeholder="手机号" style="width: 150px;"></el-input>
                      </el-form-item>
                      <el-form-item>
                        <el-input v-model="arsObj.province" type="text" placeholder="输入省" style="width: 100px;"></el-input>
                      </el-form-item>
                      <el-form-item>
                        <el-input v-model="arsObj.city" type="text" placeholder="输入市" style="width: 100px;"></el-input>
                      </el-form-item>
                      <el-form-item>
                        <el-input v-model="arsObj.area" type="text" placeholder="输入县/区" style="width: 100px;"></el-input>
                      </el-form-item>
                      <el-form-item>
                        <el-input v-model="arsObj.detail" type="text" placeholder="详细地址，街道，楼栋等" style="width: 280px;"></el-input>
                      </el-form-item>
                    </el-form>
                    <el-button @click="addAddressTwo" type="primary" size="medium">确认添加</el-button>
                  </div>
                  <div class="addressTwo-r">
                    <p>注意事项:</p>
                    <p>1.姓名，电话，地址 按顺序填写，中间用逗号分隔，一次可以输入多个收件人信息，一个收件人信息一行输入。</p>
                    <p>2.如遇东莞市、三沙市、儋州市、嘉峪关市等没有区的城市，区域可设置为“其他区”</p>
                    <p>3.为不影响您的正常发货，请留意各省市快递停发区域。 <span @click="seeSending">点击查看停发区域</span></p>
                    <br>
                    <p>示例:</p>
                    <p>张三，13888888888，湖北省 武汉市 江汉区 解放大道392号</p>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-collapse-transition>
        <!-- 收货人信息列表 -->
        <div v-if="listTableFlag" class="selectWay">
          <!-- 标题 -->
          <div class="list-title">
            <div><span class="span-one">根据导入内容，核对收件人信息</span><span class="span-two">共上传<span class="span-three">{{addressList.length}}</span>条数据</span></div>
            <div><el-button @click="uploadAgain">导入订单</el-button><el-button @click="nextStep" type="primary">信息正确,下一步</el-button></div>
          </div>
          <!-- 表格 -->
          <el-table
            :header-cell-style="{background:'#fafafa'}"
            :data="addressList.slice((currentPage - 1) * pageSize, currentPage * pageSize)"
            style="width: 100%">
            <el-table-column
              label="序号"
              min-width="10%">
              <template slot-scope="scope"><span>{{scope.$index+(currentPage - 1) * pageSize + 1}}</span></template>
            </el-table-column>
            <el-table-column
              label="订单编号"
              min-width="16%">
              <template slot-scope="scope"><span>{{scope.row.order}}</span></template>
            </el-table-column>
            <el-table-column
              prop="name"
              label="收货人姓名"
              min-width="16%"
              >
            </el-table-column>
            <el-table-column
              prop="phone"
              label="手机号"
              min-width="16%">
            </el-table-column>
            <el-table-column
              prop="address"
              label="收货地址"
              min-width="30%">
            </el-table-column>
            <el-table-column
              label="操作"
              min-width="10%"
              >
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  @click="handleEdit(scope.$index+(currentPage - 1) * pageSize + 1, scope.row)">编辑</el-button>
                <el-button
                  size="mini"
                  type="danger"
                  @click="handleDelete(scope.$index+(currentPage - 1) * pageSize + 1, scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div>
            <!-- <el-select v-model="pageSize" placeholder="请选择页面条数">
              <el-option key="3" label="3" value="3"></el-option>
              <el-option key="10" label="10" value="10"></el-option>
              <el-option key="20" label="20" value="20"></el-option>
              <el-option key="50" label="50" value="50"></el-option>
              <el-option key="100" label="100" value="100"></el-option>
              <el-option key="200" label="200" value="200"></el-option>
              <el-option key="500" label="500" value="500"></el-option>
            </el-select> -->
            <el-pagination
              @current-change="handleCurrentChange"
              background
              class="addressListPage"
              layout="prev, pager, next"
              :current-page="currentPage"
              :page-size="pageSize"
              :total="addressList.length">
            </el-pagination>
          </div>
        </div>
        <!-- 编辑表格Dialog -->
        <el-dialog title="编辑收货人信息" width="30%" :visible.sync="dialogFormVisible">
          <el-form class="editForm" :model="editObj" label-width="100px">
            <el-form-item label="订单编号" required>
              <el-input v-model="editObj.order"></el-input>
            </el-form-item>
            <el-form-item label="收货人姓名" required>
              <el-input v-model="editObj.name"></el-input>
            </el-form-item>
            <el-form-item label="手机号码" required>
              <el-input v-model="editObj.phone"></el-input>
            </el-form-item>
            <el-form-item label="省" required>
              <el-input v-model="editObj.province"></el-input>
            </el-form-item>
            <el-form-item label="市" required>
              <el-input v-model="editObj.city"></el-input>
            </el-form-item>
            <el-form-item label="区" required>
              <el-input v-model="editObj.area"></el-input>
            </el-form-item>
            <el-form-item label="详细地址" required>
              <el-input v-model="editObj.detail" type="textarea"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="dialogFormVisible = false">取 消</el-button>
            <el-button size="small" type="primary" @click="dialogFormYes">确 定</el-button>
          </div>
        </el-dialog>
        <!-- Step3 -->
        <div class="step three" ref="stepThree">
          <div><p class="stepTitle">Step3：选择礼品 <el-button type="success" size="small" @click="setDefaultkd">设置默认快递</el-button></p></div>
          <p style="color: red;">当天下午5点前下单，当天晚上揽收  5点后下单，第二天上午到中午揽收</p>
          <div class="step-body step-three">
            <!-- 左边 -->
            <div class="step-body-left" style="flex: none;">
              <div class="step">
                <div class="step-body" style="flex-wrap: wrap">
                  <div @click="stepThreeItemClick(item.id)" v-for="item in stepThree" :key="item.id" style="margin-bottom:  15px;position: relative;" class="step-body-item" :class="{ 'active': stepThreeActive == item.id }">
                    <img v-if="item.id == 1" class="logImg" src="../../../assets/kd/yd.png" />
                    <img v-if="item.id == 2" class="logImg" src="../../../assets/kd/sto.png" />
                    <img v-if="item.id == 3" class="logImg" src="../../../assets/kd/yt.png" />
                    <img v-if="item.id == 4" class="logImg" src="../../../assets/kd/zt.png" />
                    <img v-if="item.id == 12" class="logImg" src="../../../assets/kd/sf.png" />
                    <img v-if="item.id == 13" class="logImg" src="../../../assets/kd/postx.png" />
                    <img v-if="item.id == 5" class="logImg" src="../../../assets/kd/jt.png" />
                    {{ item.tag_name }}
                    <i class="menuTag hot" v-if="item.id == '4'">新仓上线</i>
                  </div>
                </div>
              </div>
              <!-- 仓库 -->
              <div class="screening">
                <div class="title">仓库:</div>
                <ul class="list">
                  <li @click="storeItemClick(index)" :class="{ 'store-screening-active': storeActive == index }" class="item store-item" style="width: 235px;position: relative;" v-for="(item, index) in storeList" :key="index">
                    <span class="store-title-span">{{item.name}}</span>
                    <i class="menuTag hot" v-if="item.is_new == '1'">新仓上线</i>
                    <!-- <div class="store-wrap-ul">
                      <div class="store-li">
                        <span class="store-title-span">{{item.name}}</span>
                        <span class="store-sign">
                          <span class="store-sign-txt" v-show="item.name.indexOf('100%') !== -1">100%</span>
                        </span>
                      </div>
                    </div> -->
                  </li>
                </ul>
              </div>
              <!-- 地址 -->
              <div class="screening" v-if="storeList && storeList[storeActive] && storeList[storeActive].storage_address">
                <div class="title">发货地址:</div>
                <ul class="list">
                  <li class="item" style="color: red;">{{storeList[storeActive].storage_address}}</li>
                </ul>
              </div>
              <!-- 排序 -->
              <div class="screening">
                <div class="title">排序:</div>
                <ul class="list">
                  <li @click="sortItemClick(index)" :class="{ 'screening-active': sortActive == index }" class="item" v-for="(item, index) in sortList" :key="index">{{item}}</li>
                </ul>
              </div>
              <!-- 礼品列表 -->
              <div class="goods">
                <div class="goods-item" v-for="(item, index) in goodsList.slice((goodsCurrentPage - 1) * goodsPageSize, goodsCurrentPage * goodsPageSize)" :key="index" @click="addGoods(item)">
                  <div class="image">
                    <img :src="item.goods_images[0]">
                  </div>
                  <div class="btn">确认礼品</div>
                  <div class="price">￥{{item.goods_price}}</div>
                  <div class="message">
                    <span>{{item.goods_name}}</span>
                    <span style="opacity: 0">{{item.goods_weight}}g</span>
                  </div>
                </div>
              </div>
              <!-- 分页 -->
              <el-pagination
                background
                @current-change="goodsHandleCurrentChange"
                :current-page="goodsCurrentPage"
                :page-size="goodsPageSize"
                layout="total, prev, pager, next, jumper"
                :total="goodsList.length">
              </el-pagination>
            </div>
            <!-- 右边 -->
            <div class="step-body-right">
              <div class="table-box">
                <!-- 表格 -->
                <el-table
                  :header-cell-style="{background:'#F5F5F5',color:'black',fontWeight:'normal'}"
                  :data="lipinList"
                  style="width: 100%">
                  <el-table-column
                    label="礼品图"
                    >
                    <template slot-scope="scope"><img :src="scope.row.goods_images[0]" width="48px" height="48px"></template>
                  </el-table-column>
                  <el-table-column
                    prop="goods_name"
                    label="礼品名称"
                    >
                  </el-table-column>
                  <el-table-column
                    prop="goods_price"
                    label="单价"
                  >
                  </el-table-column>
<!--                  <el-table-column-->
<!--                    label="数量"-->
<!--                   >-->
<!--                    <template slot-scope="scope"><span>{{(scope.row.goods_num)}}</span></template>-->
<!--                  </el-table-column>-->
                  <!-- <el-table-column
                    prop="goods_weight"
                    label="重量(kg/g)"
                    >
                  </el-table-column> -->
                  <!-- <el-table-column
                    prop="storage_name"
                    label="发货仓库"
                    >
                  </el-table-column> -->
                  <el-table-column
                    prop="goods_price"
                    label="小计"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="storage_name"
                    label="发货仓库"
                    >
                  </el-table-column>
                </el-table>
<!--                <table>-->
<!--                  <thead class="table-thead">-->
<!--                    <tr>-->
<!--                      <th>礼品图</th>-->
<!--                      <th>礼品名称</th>-->
<!--                      <th>单价</th>-->
<!--                      <th>数量</th>-->
<!--                      <th>重量（g）</th>-->
<!--                      <th>发货仓库</th>-->
<!--                      <th>小计</th>-->
<!--                    </tr>-->
<!--                  </thead>-->
<!--                  <tbody v-show="dataFlag" class="table-tbody">-->
<!--                  </tbody>-->
<!--                </table>-->
                <!-- 没有数据时显示 -->
<!--                <div v-show="!dataFlag" class="no-data">-->
<!--                  <div class="no-data-box">-->
<!--                    <i class="el-icon-takeaway-box icon" style="font-size: 45px;"></i>-->
<!--                    <p>暂无数据</p>-->
<!--                  </div>-->
<!--                </div>-->
              </div>
              <!-- 提交订单 -->
              <div class="sub-order">
                <el-form :model="goodsItem">
                  <span v-if="[361, 362, 363, 364, 365, 367, 368, 375, 371, 393, 410, 414, 432, 434, 398].indexOf(storeListItemId) !== -1" style="color: red;margin-bottom: 10px;">甘肃 宁夏 内蒙 青海  北京 上海 深圳 地区需加1元，<br />新疆,西藏区域无法派送勿拍</span>
                  <span v-if="storeListItemId === 198 || storeListItemId === 195" style="color: red;margin-bottom: 10px;">北京 内蒙古 上海 陕西 甘肃 青海 宁夏 顺丰的都额外加一块钱</span>
                  <!-- <span v-if="storeListItemId === 15" style="color: red;margin-bottom: 10px;">苏州邮政过年期间正常发货，1月19日晚20：00-2月7日23：59发全国每件加收0.6元每单，</span>
                  <span v-if="storeListItemId === 21" style="color: red;margin-bottom: 10px;">福建邮政过年期间正常发货，1月19日晚20：00-2月7日23：59发全国每件加收0.5元每单，</span>
                  <span v-if="isThird === 7" style="color: red;margin-bottom: 10px;">北京,新疆,西藏区域无法派送勿拍</span> -->
                  <el-form-item label="备注信息:">
                    <el-input v-model="remarks"></el-input>
                  </el-form-item>
                  <el-form-item label="运送方式:">
                    <el-select v-model="storageValue" placeholder="请选择快递" @change=storageSelectChange v-if="storageValue!=undefined ">
                      <el-option v-for="item in storageOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                  </el-form-item>
<!--                  <el-form-item label="发件地址:">-->
<!--                    <el-select v-model="areaListValue" placeholder="请选择发件人" @change=areaSelectChange>-->
<!--                      <el-option v-for="item in areaList" :key="item.id" :label="item.name + ' ' + item.send_phone" :value="item.id"></el-option>-->
<!--                    </el-select>-->
<!--                    <span class="xjdz" @click="mesBox">新建地址</span>-->
<!--                  </el-form-item>-->
                  <el-form-item label="收件人数:">
                    <span>{{addressList.length}}</span>
                  </el-form-item>
                  <el-form-item label="礼品总额:">
                    <span class="sub-order-color">￥{{Number(totalGifts).toFixed(2)}}</span>
                  </el-form-item>
                  <el-form-item label="礼品运费:">
                    <span>￥{{Number(freight).toFixed(2)}}</span>
                  </el-form-item>
                  <el-form-item label="特殊地区服务费:" v-if="totalExtraPrice > 0">
                    <span>￥{{Number(totalExtraPrice).toFixed(2)}}</span>
                  </el-form-item>
                  <el-form-item label="应付金额:">
                    <span class="sub-order-color">￥{{Number(payable).toFixed(2)}}</span>
                  </el-form-item>
                  <span class="sub-btn" @click="placeOrder">提交订单 ￥{{Number(payable).toFixed(2)}}</span>
                </el-form>
                <!-- <img v-if="storeListItemId === 15" src="../../../assets/images/news.jpeg" />
                <img v-if="storeListItemId === 8 || storeListItemId == 1 || storeListItemId == 2 || storeListItemId == 23" src="../../../assets/images/kuaidi.png" />
                <img v-if="storeListItemId === 8 || storeListItemId == 1" src="../../../assets/images/kuaidi2.png" /> -->
              </div>
            </div>
          </div>
        </div>
        <!-- 停发区域Dialog   {{Number(goods.salePrice).toFixed(2)}}-->
        <stop-sending :showStopSending="showStopSending" @closeStopSending="closeStopSending" :stopStoreList="stopStoreList"/>
        <!-- 付款Dialog -->
        <pay-dialog :dialogShow="dialogShow" @toOrderList="toOrderList" :name="goodsItem.goods_name" :price="payable" :money="money" :orderId="orderId"/>
        <!-- 添加地址Dialog -->
        <addressDialog :addressDialogShow="addressDialogShow" @closeAddressDialog="closeAddressDialog" @updateAddressDialog="updateAddressDialog"/>
      </template>
    </app-main>
    <div class="fiexImageWrap" v-if="isMain && fixedImage">
      <img src="../../../assets/images/haowai.jpg" @click="toPromotion" class="fiexImage"/>
      <i @click="fixedImage = false" class="el-icon-circle-close fiexIcon"></i>
    </div>
    <!-- 弹窗保存域名 -->
    <el-dialog
      title="提示"
      :visible.sync="idCardDialogVisible"
      width="50%">
      <p style="color: red;">
        根据国家 《快递暂行条例》规定，经营快递业务的企业收寄快件，应当对寄件人身份进行实名认证，认证信息只做核验，不进行任何保存。凡未核验的企业，网站将进行关停，整顿。为了网站的稳定运行请您进行身份核验
      </p>
      <el-form :model="cardShowForm" label-width="100px" :rules="cardShowForm" ref="aipayForm">
        <el-form-item label="真实姓名:" prop="aiPayName">
          <el-input v-model="cardShowForm.name" placeholder="真实姓名"></el-input>
        </el-form-item>
        <el-form-item label="身份证号:" prop="idCard">
          <el-input v-model="cardShowForm.idCard" placeholder="请输入身份证号"></el-input>
        </el-form-item>
        <el-form-item label="手机号:" prop="phone">
          <el-input v-model="cardShowForm.phone" maxLength="11" placeholder="请输入手机号"></el-input>
          <div><small style="color: red">请您确保手机号实名信息与您填写的身份信息一致</small></div>
        </el-form-item>
        <el-form-item label="验证码:" prop="code" v-if="cardShowForm.phone != loginPhone">
          <div class="dxdl">
            <el-input
              class="dxdl-code-left"
              v-model="cardShowForm.code"
              placeholder="请输入验证码"
            ></el-input>
            <el-button  class="dxdl-code-right"  @click="sendImageCode()" :disabled="!this.codeFlag || cardShowForm.phone.length != 11">{{codeBtnText}}</el-button>
          </div>
      </el-form-item>
      <el-form-item prop="imgCaptcha" v-show="showImgCode && cardShowForm.phone != loginPhone">
        <el-row :gutter="20">
          <el-col :span="5">
            <span  style="display: inline-block;width: 130px;height: 38px;border: 1px solid #D7D7D7;"  >
              <img :src="imgCode" @click="sendImageCode()"  style="width: 100%;height: 100%;cursor: pointer;" />
            </span>
          </el-col>
          <el-col :span="13" style="padding-right: 0">
            <el-input v-model="cardShowForm.imgCaptcha" type="text" @input="(value) => value.length >= 4 ? getCodes() : ''" placeholder="请输入图片验证码" maxLength="4"></el-input>
          </el-col>
        </el-row>
      </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="idCardDialogVisible = false">取 消</el-button>
        <el-button type="primary" v-if="cardShowForm.phone == loginPhone" @click="idCardUpDate">确认提交</el-button>
        <el-button type="primary" v-else @click="idCardUpDateNoPhone">确认提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import AddressParse from 'zh-address-parse' // 地址解析插件
import AppMain from 'components/baseStructure/AppMain'
import PayDialog from 'components/payDialog/PayDialog'
import addressDialog from 'components/addressDialog/index'
import StopSending from 'components/stopSending/StopSending'
// import { getAllStorage, choosePlatform, getAllGoods, goodsSearchGs, getAllCloud, createOrder, getAreaList, getUserMoney, importExcel, getStoreName, getTaoBaoOrderList, getpddOrderList, getDyOrderList } from 'network/api'
import { choosePlatform, getAllGoods, goodsSearchGs, getAllCloud2, createOrder, getAreaList, getUserMoney, importExcel, getStoreName, getTaoBaoOrderList, getpddOrderList, getDyOrderList, searchpddOrderList, searchTaoBaoOrderList, orderEndPayPrice, isSaveDomain, isSaveDomainEnd, getNewDyOrderList, idCardPhoneApi, idCardUnPhoneApi, getYcOrderListApi, getYcNewOrderListApi, setDefaultStorage, getDefaultStorage, getCode, errorOrderListApi } from 'network/api'
// import { mustTwoDecimal } from 'utils/utils'

export default {
  components: {
    AppMain,
    PayDialog,
    StopSending,
    addressDialog
  },
  inject: ['mainReload'],
  data () {
    return {
      showToastYuming: false,
      stepOne: ['淘宝/天猫', '阿里巴巴', '京东', '拼多多', '抖音', '快手', '其他'],
      stepTwo: ['模板导入', '店铺导入', '手工填写'],
      stepThree: [],
      stepThreeIndex: null,
      stepOneActive: null,
      stepThreeActive: null,
      stepTwoActive: null,
      templateImport: false, // 控制模板导入相关显示
      storeImport: false, // 控制店铺导入相关显示
      handWritten: false, // 控制手工填写相关显示
      /* 以下为地址数据 */
      textareaAddressValue: '',
      addressList: [],
      addressListTotal: null,
      currentPage: 1, // 当前页
      pageSize: 10, // 每页多少条
      listTableFlag: false, // 控制地址列表是否显示
      arsObj: {},
      dialogFormVisible: false, // 控制编辑Dialog显示
      dialogFormVisible2: false, // 控制店铺导入订单Dialog显示
      editObj: {
        order: undefined,
        name: undefined,
        phone: undefined,
        address: undefined
      }, // 编辑地址对象
      addressListItemIndex: null, // 选中地址的索引
      /* 以上为地址数据 */
      /* 以下为礼品数据 */
      storeList: [], // 仓库列表
      stopStoreList: [], // 停发仓库列表
      storeListItem: {}, // 仓库对象
      storeListItemName: '', // 仓库名字 添加礼品列表需要用到
      storeListItemId: null, // 仓库id
      sortList: ['默认', '价格从低到高', '', '重量从轻到重'],
      storeActive: 0,
      sortActive: 1,
      goodsPageSize: 20,
      goodsCurrentPage: 1,
      goodsList: [], // 礼品列表
      goodsItem: {}, // 礼品详情
      dataFlag: false, // true代表选择了礼品, false没有选择礼品
      storageValue: '', // 运送方式select绑定的数据
      storageOptions: [], // 运送方式option绑定的数据
      fprice: '', // 运费
      lipinList: [],
      /* 以上为礼品数据 */
      dialogShow: false,
      showStopSending: false,
      remarks: '', // 备注
      areaListValue: '',
      areaList: [], // 发件人列表
      area_id: '', // 地址id
      oid: '',
      oaid: '',
      platform: '', // 平台
      isThird: '', // 来源
      isThird2: '', // 来源
      platform2: '',
      money: '', // 账户余额
      orderId: '', // 订单id
      goodsType: 'goods_price', // 商品排序标识
      shopValue: '', // 选择的店铺value
      shopOptions: [],
      radio: 6, // 店铺导入的flag
      orderList: [], // 店铺导入获取的订单列表
      newList: [],
      newList1: [],
      url: '',
      addressDialogShow: false,
      selectTimes: [new Date(new Date().getTime() - 3600 * 1000 * 24 * 3), new Date()],
      minPrice: '',
      maxPrice: '',
      title: '',
      size: 2000,
      ids: '',
      notIds: '',
      pickerOptions: {
        shortcuts: [{
          text: '今天',
          onClick (picker) {
            const end = new Date()
            const start = new Date(new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate() + ' 00:00:00')
            // start.setTime(start.getTime())
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近1小时',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 1)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近3小时',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 3)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近5小时',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 5)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '昨天',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 1)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三天',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 3)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      // 特殊地区服务费
      totalExtraPrice: 0,
      fixedImage: true,
      clickRepeat: true,
      idCardDialogVisible: false,
      cardShowForm: {
        name: '',
        idCard: '',
        phone: this.$store.getters.getUserInfo.username,
        code: ''
      },
      loginPhone: this.$store.getters.getUserInfo.username,
      mineKey: '',
      // 用户设置默认快递
      userDefaultKd: null,
      // 图形验证码
      showImgCode: false,
      codeBtnText: '获取验证码',
      number: 0,
      imgCode: '',
      codeFlag: true,
      timer: null,
      // 是否是主站
      isMain: this.isMain,
      errorOrderTimer: null
    }
  },
  computed: {
    // 计算礼品总额
    totalGifts () {
      if (this.addressList.length !== 0) {
        const n = parseFloat(this.goodsItem.goods_price || 0.00) * parseFloat(this.addressList.length)
        return (n)
      } else {
        const m = parseFloat(this.goodsItem.goods_price) || 0.00
        return (m) || 0.00
      }
    },
    // // 计算运费
    freight () {
      if (this.addressList.length !== 0) {
        const f = parseFloat(this.fprice || 0.00) * parseFloat(this.addressList.length)
        return (f)
      } else {
        const y = parseFloat(this.fprice) || 0.00
        return (y) || 0.00
      }
    },
    // 计算应付金额  {{Number(goods.salePrice).toFixed(2)}}
    payable () {
      this.orderEndPayPriceMeth()
      const t = parseFloat(this.totalGifts)
      const e = parseFloat(this.freight)
      return (t + e + this.totalExtraPrice)
    }
  },
  created () {
    // 带参跳转处理
    if (this.$route.query && this.$route.query.platform) {
      console.log(this.$route.query, 'query')
      this.dealWithDataStep(this.$route.query)
    } else {
      this.getDefaultkd(0)
    }
    this.mineKey = this.$configList[window.location.host]
    // 异步请求 请求完默认设置仓库在情况快递 先注释
    // this.stepOneItemClick(0)
    // 获取所有商品
    // this.allGoods()
    this.url = this.$url
    if (window.location.host === 'lp.hzjkwl.com') {
      this.$alert('您现在访问的  http://lp.hzjkwl.com 域名即将停用，请您保存永久域名 http://www.daifaliwu.cn  访问使用。避免到期不能访问！！！', '注意', {
        confirmButtonText: '确定',
        callback: action => {}
      })
    }
    // 异步循环缓存商品 361, 362, 363, 364, 365, 367, 368, 375, 371
    this.syncGetGoodsStorage(0)
    this.toastErrorOrder()
    this.errorOrderTimer = setInterval(() => {
      this.toastErrorOrder()
    }, 600000)
  },
  methods: {
    saveUrl () {
      isSaveDomain().then(res => {
        if (res.code === 1 && res.data && res.data.is_save_url === 0 && res.data.appkey === '1459435534555418624') {
          this.$confirm('请您添加客服微信，或者保存本站永久域名 http://www.daifaliwu.cn  避免失联！', '提示', {
            confirmButtonText: '我已保存',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            isSaveDomainEnd()
          })
        }
      })
    },
    toastErrorOrder () {
      errorOrderListApi({ status: 1 }).then(res => {
        let str = ''
        res.data.data.map(item => {
          if (item.status === 1) {
            str += item.waybill_code + ', '
          }
        })
        if (str !== '') {
          this.$notify.error({
            title: '提示---有待处理异常订单',
            dangerouslyUseHTMLString: true,
            message: '<div><strong style="color: #f66">' + str + '</strong>无法发货，请尽快处理</div><div style="display: flex;justify-content: center;width: 100%;margin-top: 5px;"><a href="/account/errorOrder"><button style="background: #409eff;color: #fff;border: none;padding: 5px 15px;border-radius: 5px;" type="primary">去处理</button></a></div>',
            duration: 500000
          })
        }
      })
    },
    // 广告点击
    adClick () {
      window.open(this.$store.getters.getSiteInfo.online_service, '_blank')
    },
    toPromotion () {
      this.$router.push('/promotion')
    },
    // 选择数据来源平台点击
    stepOneItemClick (index) {
      this.stepOneActive = index
      this.stepThreeActive = this.stepThreeIndex
      this.shopValue = ''
      this.stepTwoActive = null
      this.templateImport = false
      this.storeImport = false
      this.handWritten = false
      this.listTableFlag = false
      switch (index) {
        case 0:
          this.platform = 'tb_switch'
          this.platform2 = '0'
          this.stepTwo = ['模板导入', '店铺导入', '手工填写']
          break
        case 1:
          this.platform = 'ali_switch'
          this.platform2 = '1'
          this.stepTwo = ['模板导入', '手工填写']
          break
        case 2:
          this.platform = 'jd_switch'
          this.platform2 = '2'
          this.stepTwo = ['模板导入', '店铺导入', '手工填写']
          break
        case 3:
          this.platform = 'pinxixi_switch'
          this.platform2 = '3'
          this.stepTwo = ['模板导入', '店铺导入', '手工填写']
          break
        case 4:
          this.platform = 'dy_switch'
          this.platform2 = '4'
          this.stepTwo = ['模板导入', '店铺导入', '手工填写']
          break
        case 5:
          this.platform = 'ks_switch'
          this.platform2 = '6'
          this.stepTwo = ['模板导入', '店铺导入', '手工填写']
          break
        case 6:
          this.platform = 'others_switch'
          this.platform2 = '5'
          this.stepTwo = ['模板导入', '手工填写']
          break
      }
      getAllCloud2({ key: this.$configList[window.location.host], platform: this.platform }).then(res => {
        // 2038统一处理
        // this.stepThree = res.data
        // this.stepThreeIndex = res.data[0].id
        // this.isThird = res.data[0].id
        // this.stepThreeItemClick(this.stepThreeIndex)
        this.endMailDealWith(res, 'first')
      })
      // 获取点击平台的店铺名称
      getStoreName({
        bandType: this.platform2
      }).then(res => {
        if (!res.data) {
          res.data = []
        }
        this.shopOptions = []
        for (let i = 0; i < res.data.length; i++) {
          this.shopOptions.push({
            label: res.data[i][0],
            value: res.data[i][1] // 此处value未定 等待后续确定
          })
        }
      })
      // // 点击平台不同获取仓库列表不同
      // choosePlatform({ platform: this.platform, key: this.$configList[window.location.host], isThird: this.isThird }).then(res => {
      //   if (res.code === 1) {
      //     this.storeActive = 0
      //     this.storeList = res.data
      //     this.stopStoreList = res.data
      //     this.storeListItem = this.storeList[0] // 初始化仓库对象
      //     this.storeListItemId = this.storeList[0].id
      //     this.storeListItemName = this.storeList[0].name // 获取到仓库名
      //     // 初始化礼品列表
      //     this.getGoodsSearchGs()
      //   } else {
      //     this.goodsList = []
      //   }
      // })
    },
    // 选择数据来源平台点击
    stepThreeItemClick (index) {
      if (this.stepOneActive === null) {
        this.$message({
          message: '请先选择平台',
          type: 'warning'
        })
      } else {
        this.stepThreeActive = index
        this.isThird = index
        // 点击平台不同获取仓库列表不同
        choosePlatform({
          platform: this.platform,
          key: this.$configList[window.location.host],
          isThird: this.isThird
        }).then(res => {
          if (this.isThird === 13) {
            choosePlatform({
              platform: this.platform,
              key: this.$configList[window.location.host],
              isThird: '7'
            }).then(re => {
              const data = res
              console.log(data, res, re, '仓库列表')
              if (re.data) {
                data.data = [
                  ...data.data,
                  ...re.data
                ]
              }
              console.log(data, 'data')
              this.endMailDealWith(data, 'second')
            })
          } else {
            this.endMailDealWith(res, 'second')
          }
        })
      }
    },
    // 获取所有商品请求
    allGoods () {
      // getAllGoods().then(res => {
      //   this.goodsList = res.data
      // })
      getAllGoods({ key: this.$configList[window.location.host] }).then(res => {
        this.goodsList = res.data
      })
    },
    // 商品筛选请求
    getGoodsSearchGs () {
      const sessionKey = this.storeListItemId + '__' + this.goodsType
      if (sessionStorage.getItem(sessionKey)) {
        this.goodsList = JSON.parse(sessionStorage.getItem(sessionKey)) || []
      } else {
        goodsSearchGs({
          storage_id: this.storeListItemId,
          goods_type: this.goodsType,
          key: this.$configList[window.location.host]
        }).then(res => {
          // 筛选倒序数组
          switch (this.goodsType) {
            // 价格从低到高
            case 'goods_price':
              this.goodsList = res.data.reverse()
              break
            // 销量从低到高
            case 'goods_num':
              this.goodsList = res.data.reverse()
              break
            // 重量从轻到重
            case 'goods_weight':
              this.goodsList = res.data.reverse()
              break
            // 默认
            default:
              this.goodsList = res.data
              break
          }
          sessionStorage.setItem(sessionKey, JSON.stringify(this.goodsList))
        })
      }
    },
    // 循环缓存大数量量商品
    syncGetGoodsStorage (index) {
      // if (index >= 8) return
      // const storageList = [361, 362, 364, 365, 367, 368, 375, 371, 393]
      // const sessionKey = storageList[index] + '__goods_price'
      // if (!sessionStorage.getItem(sessionKey)) {
      //   goodsSearchGs({
      //     storage_id: storageList[index],
      //     goods_type: 'goods_price',
      //     key: this.$configList[window.location.host]
      //   }).then(res => {
      //     sessionStorage.setItem(sessionKey, JSON.stringify(res.data.reverse()))
      //     this.syncGetGoodsStorage(index + 1)
      //   })
      // } else {
      //   this.syncGetGoodsStorage(index + 1)
      // }
    },
    // 店铺切换 清空数据
    shopChangeClear () {
      console.log('aaa')
      this.addressList = []
    },
    // 录入收件人信息的方式点击
    stepTwoItemClick (item, index) {
      // 需要先选中平台
      if (this.stepOneActive != null) {
        this.stepTwoActive = index
        switch (item) {
          case '模板导入':
            this.templateImport = true
            this.storeImport = false
            this.handWritten = false
            this.listTableFlag = false
            this.textareaAddressValue = ''
            this.addressList = []
            this.shopValue = ''
            break
          case '店铺导入':
            this.templateImport = false
            this.storeImport = true
            this.handWritten = false
            this.listTableFlag = false
            this.textareaAddressValue = ''
            break
          case '手工填写':
            this.templateImport = false
            this.storeImport = false
            this.handWritten = true
            this.listTableFlag = false
            this.textareaAddressValue = ''
            this.shopValue = ''
            break
        }
      } else {
        this.$message({
          message: '请先选择平台',
          type: 'warning'
        })
      }
    },
    jumpToStoreBind () {
      this.$router.push('storeBind')
    },
    // 地址格式一
    addAddressOne () {
      const v = this.textareaAddressValue // textarea 输入内容
      // 判断输入内容是否为空
      if (v === '') {
        this.$message({
          message: '请输入地址',
          type: 'warning'
        })
        return false
      }
      // 将输入内容转为数组
      let infoArray = [] // textarea 数组
      infoArray = v.split('\n')
      for (let i = 0; i < infoArray.length; i++) {
        if (infoArray[i] === '') {
          infoArray.splice(i, 1) // 去掉值为空的数组
          i = i - 1
        }
      }
      this.addressList = infoArray
      for (let i = 0; i < infoArray.length; i++) {
        const info = infoArray[i]
        const c = info.indexOf(',')
        const c1 = info.indexOf('，')
        if (c === -1 && c1 === -1) {
          this.$message({
            message: '地址格式错误，姓名后面必须包含,分割',
            type: 'warning'
          })
          return false
        }
        let infoAddressArray = [] // textarea 数组
        infoAddressArray = info.split(/,|，/)
        let userName = infoAddressArray[0]
        // 地址格式无法格式详细地址 有问题打开注释
        // infoAddressArray.shift()
        let cs = infoAddressArray.join()
        let a = ''
        let fj = ''
        // console.log(cs)
        // console.log(cs.match(/天津|重庆|上海|北京/g))
        // let toastArea = ''
        // if (cs.match(/天津|重庆|上海|北京/g) && cs.match(/天津|重庆|上海|北京/g).length && cs.match(/天津|重庆|上海|北京/g).length > 1) {
        //   toastArea = ', 请去掉一个' + cs.match(/天津|重庆|上海|北京/g)[0] + '或者是去掉' + cs.match(/天津|重庆|上海|北京/g)[0] + '市'
        // } else {
        //   toastArea = ''
        // }
        // console.log(cs, cs.match(/^86-/), 'aaa')
        // if (cs.match(/^86-/)) {
        //   cs = cs.split('86-1').join('')
        // }
        if (cs.indexOf('86-1') !== -1) {
          cs = cs.split('86-1').join('1')
        }
        console.log(cs, 'bbb')
        if (cs.match(/-+[0-9]{4}/)) {
          const phoneZ = cs.match(/-+[0-9]{4}/)[0]
          cs = cs.split(phoneZ).join('') + '[' + phoneZ.split('-').join('') + ']'
        }
        if (cs.indexOf('市市') !== -1) {
          cs = cs.replace(/市市/g, '市')
        }
        console.log(cs, 'ccc')
        if (cs.match(/\[(.+?)\]/)) {
          const sjList = cs.match(/\[(.+?)\]/)
          fj = sjList[0]
          a = AddressParse(cs.split(fj).join(''))
          userName = userName.split(fj).join('')
        } else {
          a = AddressParse(cs)
        }
        a.name = userName
        // console.log(a, 'aa')
        // 判断格式是否正确
        if (a.name === '' || a.phone === '' || a.province === '' || a.city === '' || a.detail === '') {
          this.$message({
            message: '第' + (i + 1) + '行地址格式错误',
            type: 'warning'
          })
          return false
        } else {
          if (fj) {
            // if (!a.detail.match(/\[(.+?)\]/)) {
            //   a.detail = a.detail + a.name.match(/\[(.+?)\]/)[0]
            // }
            a.name = a.name + fj
            a.detail = a.detail + fj
          }
          this.listTableFlag = true // 显示地址列表
          this.arsObj = a
          this.arsObj.detail = a.detail
          this.arsObj.order = this.randomNo(3) // 添加一个随机订单号
          this.arsObj.address = a.province + a.city + a.area + a.detail
          this.addressList[i] = this.arsObj
        }
      }
      if (this.addressList.length !== 0) {
        for (let i = 0; i < this.addressList.length; i++) {
          if (this.addressList[i].name === '' || this.addressList[i].phone === '' || this.addressList[i].address === '') {
            this.$message.error('第' + (i + 1) + '条收件人数据不全')
            return false
          }
          if (this.addressList[i].phone.length >= 11 && !(/^1[3|4|5|6|9|7|8][0-9]{9}$/.test(this.addressList[i].phone.substr(Number(this.addressList[i].phone.length) - 11)))) {
            this.$message.error('第' + (i + 1) + '条收件人手机号有误')
            return false
          }
        }
      }
    },
    // 地址格式一  京东需填写真实订单号
    addAddressOneJd () {
      const v = this.textareaAddressValue // textarea 输入内容
      // 判断输入内容是否为空
      if (v === '') {
        this.$message({
          message: '请输入地址',
          type: 'warning'
        })
        return false
      }
      // 将输入内容转为数组
      let infoArray = [] // textarea 数组
      infoArray = v.split('\n')
      for (let i = 0; i < infoArray.length; i++) {
        if (infoArray[i] === '') {
          infoArray.splice(i, 1) // 去掉值为空的数组
          i = i - 1
        }
      }
      this.addressList = infoArray
      for (let i = 0; i < infoArray.length; i++) {
        const info = infoArray[i]
        const c = info.indexOf(',')
        const c1 = info.indexOf('，')
        if (c === -1 && c1 === -1) {
          this.$message({
            message: '地址格式错误，姓名后面必须包含,分割',
            type: 'warning'
          })
          return false
        }
        let infoAddressArray = [] // textarea 数组
        infoAddressArray = info.split(/,|，/)
        let userName = ''
        let cs = ''
        let orderOn = ''
        console.log(infoAddressArray.length, 'infoAddressArray.length')
        if (infoAddressArray.length === 4) {
          orderOn = infoAddressArray[0]
          userName = infoAddressArray[1]
          infoAddressArray.shift()
          cs = infoAddressArray.join()
        } else {
          userName = infoAddressArray[0]
          cs = infoAddressArray.join()
        }
        // let userName = infoAddressArray[0]
        // 地址格式无法格式详细地址 有问题打开注释
        // infoAddressArray.shift()
        // let cs = infoAddressArray.join()
        let a = ''
        let fj = ''
        if (cs.indexOf('86-1') !== -1) {
          cs = cs.split('86-1').join('1')
        }
        if (cs.match(/-+[0-9]{4}/)) {
          const phoneZ = cs.match(/-+[0-9]{4}/)[0]
          cs = cs.split(phoneZ).join('') + '[' + phoneZ.split('-').join('') + ']'
        }
        if (cs.indexOf('市市') !== -1) {
          cs = cs.replace(/市市/g, '市')
        }
        if (cs.match(/\[(.+?)\]/)) {
          const sjList = cs.match(/\[(.+?)\]/)
          fj = sjList[0]
          console.log(fj, 'aaaa')
          console.log(orderOn, !orderOn, '!orderOn')
          if (!orderOn) {
            this.$message.error('第' + (i + 1) + '条地址为虚拟手机号，请在姓名前面添加真实的京东订单号并以逗号隔开')
            return false
          }
          a = AddressParse(cs.split(fj).join(''))
          userName = userName.split(fj).join('')
        } else {
          a = AddressParse(cs)
        }
        a.name = userName
        // 判断格式是否正确
        if (a.name === '' || a.phone === '' || a.province === '' || a.city === '' || a.detail === '') {
          this.$message({
            message: '第' + (i + 1) + '行地址格式错误',
            type: 'warning'
          })
          return false
        } else {
          if (fj) {
            // if (!a.detail.match(/\[(.+?)\]/)) {
            //   a.detail = a.detail + a.name.match(/\[(.+?)\]/)[0]
            // }
            a.name = a.name + fj
            a.detail = a.detail + fj
          }
          this.listTableFlag = true // 显示地址列表
          this.arsObj = a
          this.arsObj.detail = a.detail
          this.arsObj.order = orderOn || this.randomNo(3) // 添加一个随机订单号
          this.arsObj.address = a.province + a.city + a.area + a.detail
          this.addressList[i] = this.arsObj
        }
      }
      if (this.addressList.length !== 0) {
        for (let i = 0; i < this.addressList.length; i++) {
          if (this.addressList[i].name === '' || this.addressList[i].phone === '' || this.addressList[i].address === '') {
            this.$message.error('第' + (i + 1) + '条收件人数据不全')
            return false
          }
          if (this.addressList[i].phone.length >= 11 && !(/^1[3|4|5|6|9|7|8][0-9]{9}$/.test(this.addressList[i].phone.substr(Number(this.addressList[i].phone.length) - 11)))) {
            this.$message.error('第' + (i + 1) + '条收件人手机号有误')
            return false
          }
        }
      }
    },
    // 地址格式二
    addAddressTwo () {
      const v = this.arsObj.phone + this.arsObj.province + this.arsObj.city + this.arsObj.area + this.arsObj.detail
      const a = AddressParse(v)
      a.name = this.arsObj.name
      if (!this.arsObj.name || !this.arsObj.phone || !this.arsObj.province || !this.arsObj.city || !this.arsObj.area || !this.arsObj.detail) {
        this.$message({
          message: '请完善信息',
          type: 'warning'
        })
      } else if (a.name === '' || a.phone === '' || a.province === '' || a.city === '' || a.area === '' || a.detail === '') {
        this.$message({
          message: '地址格式错误',
          type: 'warning'
        })
      } else {
        this.listTableFlag = true // 显示地址列表
        this.arsObj.order = this.arsObj.order ? this.arsObj.order : this.randomNo(3)
        this.arsObj.address = this.arsObj.province + this.arsObj.city + this.arsObj.area + this.arsObj.detail
        this.addressList.push(this.arsObj)
        this.arsObj = {}
      }
    },
    getOrderListByStoreName () {
      // console.log(this.$configList[window.location.host])
      if (this.radio === 6) {
        const a = null
        this.getding(a)
        this.addressList = this.newList
      } else {
        this.getding(this.radio)
        this.addressList = this.newList
      }
    },
    getding (zhi) {
      this.newList = []
      if (!this.shopValue) {
        this.$message({
          message: '请先选择店铺',
          type: 'warning'
        })
      } else {
        const queryData = {
          createtime: this.selectTimes,
          minPrice: this.minPrice,
          maxPrice: this.maxPrice,
          size: this.size,
          title: this.title,
          ids: this.ids ? this.ids.split(/[\n]/).join(',') : '',
          notIds: this.notIds ? this.notIds.split(/[\n]/).join(',') : ''
        }
        if (this.platform2 === '0') {
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          getTaoBaoOrderList({
            tbseller: this.shopValue,
            seller_flag: zhi,
            ...queryData
          }).then(res => {
            loading.close()
            if (res.data) {
              for (let i = 0; i < res.data.length; i++) {
                // res.data[i].receive.receiver_address = res.data[i].receive.receiver_state + res.data[i].receive.receiver_city + res.data[i].receive.receiver_district + res.data[i].receive.receiver_address
                this.newList.push({
                  name: res.data[i].receive.receiver_name,
                  address: res.data[i].receive.receiver_state + res.data[i].receive.receiver_city + res.data[i].receive.receiver_district + res.data[i].receive.receiver_address,
                  province: res.data[i].receive.receiver_state,
                  city: res.data[i].receive.receiver_city,
                  area: res.data[i].receive.receiver_district,
                  phone: res.data[i].receive.receiver_mobile,
                  detail: res.data[i].receive.receiver_address,
                  order: res.data[i].receive.tid,
                  oaid: res.data[i].receive.oaid,
                  nick: res.data[i].receive.buyer_nick,
                  title: res.data[i].oid.title,
                  seller_flag: res.data[i].receive.seller_flag,
                  payment: res.data[i].receive.payment,
                  created: res.data[i].receive.created
                })
              }
            }
            if (res.code !== 1) {
              this.$message({
                message: res.msg,
                type: 'warning'
              })
            }
          })
        } else if (this.platform2 === '3') {
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          getpddOrderList({
            pddSeller: this.shopValue,
            seller_flag: zhi,
            ...queryData
          }).then(res => {
            loading.close()
            if (res.data) {
              for (let i = 0; i < res.data.length; i++) {
                // res.data[i].receive.receiver_address = res.data[i].receive.receiver_state + res.data[i].receive.receiver_city + res.data[i].receive.receiver_district + res.data[i].receive.receiver_address
                this.newList.push({
                  name: res.data[i].receive.receiver_name,
                  address: res.data[i].receive.receiver_state + res.data[i].receive.receiver_city + res.data[i].receive.receiver_district + res.data[i].receive.receiver_address,
                  province: res.data[i].receive.receiver_state,
                  city: res.data[i].receive.receiver_city,
                  area: res.data[i].receive.receiver_district,
                  phone: res.data[i].receive.receiver_mobile,
                  detail: res.data[i].receive.receiver_address,
                  order: res.data[i].receive.tid,
                  nick: res.data[i].buyer_nick,
                  title: res.data[i].oid.title,
                  seller_flag: res.data[i].receive.seller_flag,
                  payment: res.data[i].receive.payment,
                  created: res.data[i].receive.created
                })
              }
            }
            if (res.code !== 1) {
              this.$message({
                message: res.msg,
                type: 'warning'
              })
            }
          })
        } else if (this.platform2 === '4') {
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          getDyOrderList({
            shopId: this.shopValue,
            seller_flag: zhi,
            ...queryData
          }).then(res => {
            loading.close()
            if (res.data) {
              for (let i = 0; i < res.data.length; i++) {
                // res.data[i].receive.receiver_address = res.data[i].receive.receiver_state + res.data[i].receive.receiver_city + res.data[i].receive.receiver_district + res.data[i].receive.receiver_address
                this.newList.push({
                  name: res.data[i].receive.receiver_name,
                  address: res.data[i].receive.receiver_state + res.data[i].receive.receiver_city + res.data[i].receive.receiver_district + res.data[i].receive.receiver_address,
                  province: res.data[i].receive.receiver_state,
                  city: res.data[i].receive.receiver_city,
                  area: res.data[i].receive.receiver_district,
                  phone: res.data[i].receive.receiver_mobile,
                  detail: res.data[i].receive.receiver_address,
                  order: res.data[i].receive.tid,
                  nick: res.data[i].buyer_nick,
                  title: res.data[i].oid.title,
                  seller_flag: res.data[i].receive.seller_flag,
                  payment: res.data[i].receive.payment,
                  created: res.data[i].receive.created
                })
              }
            }
            if (res.code !== 1) {
              this.$message({
                message: res.msg,
                type: 'warning'
              })
            }
          })
        } else if (this.platform2 === '2' || this.platform2 === '6') {
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          getYcOrderListApi({
            shopId: this.shopValue,
            seller_flag: zhi,
            ...queryData
          }).then(res => {
            loading.close()
            if (res.data) {
              for (let i = 0; i < res.data.length; i++) {
                // res.data[i].receive.receiver_address = res.data[i].receive.receiver_state + res.data[i].receive.receiver_city + res.data[i].receive.receiver_district + res.data[i].receive.receiver_address
                this.newList.push({
                  name: res.data[i].receive.receiver_name,
                  address: res.data[i].receive.receiver_state + res.data[i].receive.receiver_city + res.data[i].receive.receiver_district + res.data[i].receive.receiver_address,
                  province: res.data[i].receive.receiver_state,
                  city: res.data[i].receive.receiver_city,
                  area: res.data[i].receive.receiver_district,
                  phone: res.data[i].receive.receiver_mobile,
                  detail: res.data[i].receive.receiver_address,
                  order: res.data[i].receive.tid,
                  nick: res.data[i].buyer_nick,
                  title: res.data[i].oid.title,
                  seller_flag: res.data[i].receive.seller_flag,
                  payment: res.data[i].receive.payment,
                  created: res.data[i].receive.created
                })
              }
            }
            if (res.code !== 1) {
              this.$message({
                message: res.msg,
                type: 'warning'
              })
            }
          })
        }
      }
    },
    searchOrderListByStoreName () {
      // console.log(this.$configList[window.location.host])
      console.log(this.ids.split(/[\n]/).join(','), 'ids')
      this.currentPage = 1
      if (this.radio === 6) {
        const a = null
        this.getSearchding(a)
        this.addressList = this.newList
      } else {
        this.getSearchding(this.radio)
        this.addressList = this.newList
      }
    },
    getSearchding (zhi) {
      this.newList = []
      if (!this.shopValue) {
        this.$message({
          message: '请先选择店铺',
          type: 'warning'
        })
      } else {
        if (this.platform2 === '0') {
          searchTaoBaoOrderList({
            tbseller: this.shopValue,
            seller_flag: zhi,
            createtime: this.selectTimes,
            minPrice: this.minPrice,
            maxPrice: this.maxPrice,
            size: this.size,
            title: this.title,
            ids: this.ids ? this.ids.split(/[\n]/).join(',') : '',
            notIds: this.notIds ? this.notIds.split(/[\n]/).join(',') : ''
          }).then(res => {
            if (res.data) {
              for (let i = 0; i < res.data.length; i++) {
                // res.data[i].receive.receiver_address = res.data[i].receive.receiver_state + res.data[i].receive.receiver_city + res.data[i].receive.receiver_district + res.data[i].receive.receiver_address
                this.newList.push({
                  name: res.data[i].receive.receiver_name,
                  address: res.data[i].receive.receiver_state + res.data[i].receive.receiver_city + res.data[i].receive.receiver_district + res.data[i].receive.receiver_address,
                  province: res.data[i].receive.receiver_state,
                  city: res.data[i].receive.receiver_city,
                  area: res.data[i].receive.receiver_district,
                  phone: res.data[i].receive.receiver_mobile,
                  detail: res.data[i].receive.receiver_address,
                  order: res.data[i].receive.tid,
                  oaid: res.data[i].receive.oaid,
                  nick: res.data[i].receive.buyer_nick,
                  title: res.data[i].oid.title,
                  seller_flag: res.data[i].receive.seller_flag,
                  payment: res.data[i].receive.payment,
                  created: res.data[i].receive.created
                })
              }
            }
            if (res.code !== 1) {
              this.$message({
                message: res.msg,
                type: 'warning'
              })
            }
          })
        } else if (this.platform2 === '3') {
          searchpddOrderList({
            pddSeller: this.shopValue,
            seller_flag: zhi,
            createtime: this.selectTimes,
            minPrice: this.minPrice,
            maxPrice: this.maxPrice,
            size: this.size,
            title: this.title,
            ids: this.ids ? this.ids.split(/[\n]/).join(',') : '',
            notIds: this.notIds ? this.notIds.split(/[\n]/).join(',') : ''
          }).then(res => {
            if (res.data) {
              for (let i = 0; i < res.data.length; i++) {
                // res.data[i].receive.receiver_address = res.data[i].receive.receiver_state + res.data[i].receive.receiver_city + res.data[i].receive.receiver_district + res.data[i].receive.receiver_address
                this.newList.push({
                  name: res.data[i].receive.receiver_name,
                  address: res.data[i].receive.receiver_state + res.data[i].receive.receiver_city + res.data[i].receive.receiver_district + res.data[i].receive.receiver_address,
                  province: res.data[i].receive.receiver_state,
                  city: res.data[i].receive.receiver_city,
                  area: res.data[i].receive.receiver_district,
                  phone: res.data[i].receive.receiver_mobile,
                  detail: res.data[i].receive.receiver_address,
                  order: res.data[i].receive.tid,
                  nick: res.data[i].buyer_nick,
                  title: res.data[i].oid.title,
                  seller_flag: res.data[i].receive.seller_flag,
                  payment: res.data[i].receive.payment,
                  created: res.data[i].receive.created
                })
              }
            }
            if (res.code !== 1) {
              this.$message({
                message: res.msg,
                type: 'warning'
              })
            }
          })
        } else if (this.platform2 === '4') {
          getNewDyOrderList({
            shopId: this.shopValue,
            seller_flag: zhi,
            createtime: this.selectTimes,
            minPrice: this.minPrice,
            maxPrice: this.maxPrice,
            ids: this.ids ? this.ids.split(/[\n]/).join(',') : '',
            notIds: this.notIds ? this.notIds.split(/[\n]/).join(',') : '',
            size: this.size,
            title: this.title
          }).then(res => {
            if (res.data) {
              for (let i = 0; i < res.data.length; i++) {
                // res.data[i].receive.receiver_address = res.data[i].receive.receiver_state + res.data[i].receive.receiver_city + res.data[i].receive.receiver_district + res.data[i].receive.receiver_address
                this.newList.push({
                  name: res.data[i].receive.receiver_name,
                  address: res.data[i].receive.receiver_state + res.data[i].receive.receiver_city + res.data[i].receive.receiver_district + res.data[i].receive.receiver_address,
                  province: res.data[i].receive.receiver_state,
                  city: res.data[i].receive.receiver_city,
                  area: res.data[i].receive.receiver_district,
                  phone: res.data[i].receive.receiver_mobile,
                  detail: res.data[i].receive.receiver_address,
                  order: res.data[i].receive.tid,
                  nick: res.data[i].buyer_nick,
                  title: res.data[i].oid.title,
                  seller_flag: res.data[i].receive.seller_flag,
                  payment: res.data[i].receive.payment,
                  created: res.data[i].receive.created
                })
              }
            }
            if (res.code !== 1) {
              this.$message({
                message: res.msg,
                type: 'warning'
              })
            }
          })
        } else if (this.platform2 === '2' || this.platform2 === '6') {
          getYcNewOrderListApi({
            shopId: this.shopValue,
            seller_flag: zhi,
            createtime: this.selectTimes,
            minPrice: this.minPrice,
            maxPrice: this.maxPrice,
            ids: this.ids ? this.ids.split(/[\n]/).join(',') : '',
            notIds: this.notIds ? this.notIds.split(/[\n]/).join(',') : '',
            size: this.size,
            title: this.title
          }).then(res => {
            if (res.data) {
              for (let i = 0; i < res.data.length; i++) {
                // res.data[i].receive.receiver_address = res.data[i].receive.receiver_state + res.data[i].receive.receiver_city + res.data[i].receive.receiver_district + res.data[i].receive.receiver_address
                this.newList.push({
                  name: res.data[i].receive.receiver_name,
                  address: res.data[i].receive.receiver_state + res.data[i].receive.receiver_city + res.data[i].receive.receiver_district + res.data[i].receive.receiver_address,
                  province: res.data[i].receive.receiver_state,
                  city: res.data[i].receive.receiver_city,
                  area: res.data[i].receive.receiver_district,
                  phone: res.data[i].receive.receiver_mobile,
                  detail: res.data[i].receive.receiver_address,
                  order: res.data[i].receive.tid,
                  nick: res.data[i].buyer_nick,
                  title: res.data[i].oid.title,
                  seller_flag: res.data[i].receive.seller_flag,
                  payment: res.data[i].receive.payment,
                  created: res.data[i].receive.created
                })
              }
            }
            if (res.code !== 1) {
              this.$message({
                message: res.msg,
                type: 'warning'
              })
            }
          })
        }
      }
    },
    /* 以下为地址列表的方法 */
    // 重新上传
    uploadAgain () {
      this.listTableFlag = false
      this.addressList = []
      this.arsObj = {}
      this.editObj = {}
      switch (this.stepTwoActive) {
        case 0:
          this.templateImport = true
          break
        case 1:
          break
        case 2:
          this.textareaAddressValue = ''
          break
      }
    },
    // 信息正确,下一步
    nextStep () {
      const a = this.$refs.ad.offsetHeight // 顶部广告位的高度
      const o = this.$refs.stepThree.offsetTop // 距离父元素顶部的高度
      this.$refs.main.$parent.$parent.$refs.main.scrollTop = o - a
    },
    // 店铺导入订单编辑
    handleOrderListEdit (index, row) {
      this.addressListItemIndex = index - 1
      this.dialogFormVisible2 = true
      console.log(row)
      const _row = row
      row = Object.assign({}, _row)
      this.editObj = row
    },
    handleOrderListDelete (index) {
      this.addressList.splice(index - 1, 1)
      if (this.addressList.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize).length <= 0) {
        this.currentPage = this.currentPage - 1
      }
    },
    // 编辑
    handleEdit (index, row) {
      this.addressListItemIndex = index - 1
      this.dialogFormVisible = true
      const _row = row
      this.editObj = Object.assign({}, _row)
      console.log(row, 'row')
    },
    // 删除
    handleDelete (index, row) {
      this.addressList.splice(index - 1, 1)
    },
    // 当前页
    handleCurrentChange (val) {
      this.currentPage = val
    },
    // Dialog 确定
    dialogFormYes () {
      this.dialogFormVisible = false
      this.dialogFormVisible2 = false
      // 修改原数组地址
      if (this.editObj.detail) {
        this.editObj.address = this.editObj.province + this.editObj.city + this.editObj.area + this.editObj.detail
      }
      this.addressList.splice(this.addressListItemIndex, 1, this.editObj)
    },
    /* 以上为地址列表的方法 */
    /* 以下为礼品列表的方法 */
    // 仓库筛选点击
    storeItemClick (index) {
      if (this.stepOneActive === null) {
        this.$message({
          message: '请先选择平台',
          type: 'warning'
        })
      } else {
        // console.log(new Date().getHours())
        if (this.storeList[index].id === 8 && new Date().getHours() > 19) {
          this.$confirm('该仓库19点前下单，当天揽收发出，19点后下单，无法保证24小时内揽收发出！', '提示', {
            confirmButtonText: '确定',
            showCancelButton: false,
            type: 'warning'
          }).then(() => {})
        }
        this.goodsCurrentPage = 1
        this.storeActive = index
        this.storeListItem = this.storeList[index] // 仓库对象
        this.storeListItemName = this.storeList[index].name // 获取到仓库名
        this.storeListItemId = this.storeList[index].id // 获取到仓库ID
        // 根据仓库获取礼品列表
        this.getGoodsSearchGs()
        // 清空选择的礼品
        this.storageOptions = []
        this.lipinList = []
        this.dataFlag = false
        this.storageValue = ''
        this.fprice = '0.00'
        this.goodsItem = {}
        // 18点以后会揽收超时
        // if (this.storeList[index].id === 410 && new Date().getHours() >= 18) {
        //   this.$alert('该仓库每天只揽收一次，18点后下单会揽收超时，请18点前下单或者换仓库下单！', '注意', {
        //     confirmButtonText: '确定',
        //     callback: () => {}
        //   })
        // }
      }
    },
    // 排序筛选点击
    sortItemClick (index) {
      this.sortActive = index
      switch (index) {
        case 0:
          this.goodsType = ''
          if (!this.storeListItemId) {
            this.allGoods()
          } else {
            this.getGoodsSearchGs()
          }
          break
        case 1:
          this.goodsType = 'goods_price'
          this.getGoodsSearchGs()
          break
        case 2:
          this.goodsType = 'goods_num'
          this.getGoodsSearchGs()
          break
        case 3:
          this.goodsType = 'goods_weight'
          this.getGoodsSearchGs()
          break
      }
    },
    // 添加礼品
    addGoods (item) {
      // 首先需要判断是否选择了平台
      if (this.stepOneActive != null) {
        // 添加前清空
        this.storageOptions = []
        // 选中的礼品详情
        this.lipinList = []
        this.lipinList.push(item)
        this.dataFlag = true
        this.goodsItem = item
        this.fprice = this.storeListItem.deliver_price
        // this.fprice = this.storeListItem
        // // 选择仓库<el-option>使用
        const v = {}
        v.value = this.storeListItem.id
        v.label = this.storeListItem.deliver_name + ' / ' + this.storeListItem.deliver_price + '元'
        v.freight_price = this.storeListItem.deliver_price
        this.storageOptions.push(v)
        this.storageValue = this.storageOptions[0].value // 初始化<el-select>选中
        this.fPrice = this.storageOptions[0].freight_price // 初始化运费
        // this.dataFlag = true // 礼品列表显示标识
        // /* 以下为创建一个行添加到表格 */
        // // 获取tbody
        // var tb = document.getElementsByClassName('table-tbody')[0]
        // // 添加前清空子元素
        // tb.innerHTML = ''
        // // 创建行
        // var tr = document.createElement('tr')
        // // 第一列
        // var imgTd = document.createElement('td')
        // var img = document.createElement('img')
        // img.src = item.goods_images[0]
        // imgTd.appendChild(img)
        // tr.appendChild(imgTd)
        // // 第二列
        // var nameTd = document.createElement('td')
        // nameTd.innerHTML = item.goods_name
        // tr.appendChild(nameTd)
        // // 第三列
        // var priceTd = document.createElement('td')
        // priceTd.innerHTML = item.goods_price
        // tr.appendChild(priceTd)
        // // 第四列
        // var numberTd = document.createElement('td')
        // numberTd.innerHTML = 1
        // tr.appendChild(numberTd)
        // // 第五列
        // var weightTd = document.createElement('td')
        // weightTd.innerHTML = item.goods_weight
        // tr.appendChild(weightTd)
        // // 第六列
        // var storeTd = document.createElement('td')
        // storeTd.innerHTML = this.storeListItemName
        // tr.appendChild(storeTd)
        // // 第七列
        // var subtotalTd = document.createElement('td')
        // subtotalTd.innerHTML = item.goods_price
        // tr.appendChild(subtotalTd)
        // // 添加样式
        // var tds = tr.children
        // img.style.width = '48px'
        // img.style.height = '48px'
        // for (let i = 0; i < tds.length; i++) {
        //   tds[i].style.padding = '16px'
        //   tds[i].style.borderBottom = '1px solid #e8e8e8'
        // }
        // // 添加到tbody
        // tb.appendChild(tr)
        /* 以上为创建一个行添加到表格 */
        /* 获取到发件人列表 */
        getAreaList().then(res => {
          this.areaList = res.data // 发件人地址列表
          for (let i = 0; i < this.areaList.length; i++) {
            if (this.areaList[i].status === '1') {
              this.areaListValue = this.areaList[i].name + ' ' + this.areaList[i].send_phone // 初始化默认发件人地址
              this.area_id = this.areaList[i].id // 初始化发件人地址id
              this.oid = this.areaList[i].oid //
              return
            }
          }
        })
      } else {
        this.$message({
          message: '请先选择平台',
          type: 'warning'
        })
      }
    },
    // 分页 当前页
    goodsHandleCurrentChange (val) {
      this.goodsCurrentPage = val
    },
    // 提交订单
    placeOrder () {
      // console.log(this.storeList[this.storeActive].id, this.stepTwoActive)
      // 判断编辑后的地址格式是否正确
      if (this.addressList.length !== 0) {
        for (let i = 0; i < this.addressList.length; i++) {
          if (this.addressList[i].name === '' || this.addressList[i].phone === '' || this.addressList[i].address === '') {
            this.$message.error('第' + (i + 1) + '条收件人数据不全')
            return false
          }
          // if (!(/^1[3|4|5|6|9|7|8][0-9]{9}$/.test(this.addressList[i].phone))) {
          //   this.$message.error('第' + (i + 1) + '条收件人手机号有误')
          //   return false
          // }
        }
      }
      if (!this.dataFlag) {
        this.$message.error('请选择礼品')
      } else if (this.addressList.length === 0) {
        this.$message.error('请至少填写一个收货地址')
      // } else if (this.areaList.length === 0 || this.areaListValue === '') {
      //   this.$message.error('请选择发货地址')
      } else {
        // 获取账户余额
        getUserMoney().then(res => {
          this.money = res.data.usermoney
        })
        const a = this.addressList
        const postData = {}
        postData.real_list = []
        for (let i = 0; i < a.length; i++) {
          const item = {}
          item.third_order_no = a[i].order
          item.receive_name = a[i].name
          item.receive_phone = a[i].phone
          item.receive_province = a[i].province
          item.receive_city = a[i].city
          item.receive_town = a[i].area
          item.receive_address = a[i].detail
          item.receive_oaid = a[i].oaid
          postData.real_list.push(item)
        }
        postData.goods_id = this.goodsItem.id
        postData.storage_id = this.storeListItemId
        postData.order_tips = this.remarks
        postData.area_id = this.area_id
        postData.oaid = this.oaid
        postData.platform = this.platform2
        postData.key = this.$configList[window.location.host]
        postData.add_url = window.location.host
        if (this.shopValue) {
          postData.order_type = this.shopValue
        }
        if (this.clickRepeat === false) return
        this.clickRepeat = false
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        createOrder(postData).then(res => {
          loading.close()
          if (res.code === 1) {
            this.orderId = res.data.order_id
            this.dialogShow = true
          } else if (res.code === -1) {
            this.$message('请先进行实名认证')
            this.idCardDialogVisible = true
            // setTimeout(() => {
            //   this.$message('请先进行实名认证，即将跳转实名认证界面，2')
            // }, 1000)
            // setTimeout(() => {
            //   this.$router.push('/account/base')
            // }, 2000)
          } else {
            // this.$message(res.msg)
            this.$alert(res.msg, '提示', { confirmButtonText: '确定' })
          }
          this.clickRepeat = true
        })
      }
    },
    idCardUpDate () {
      if (!this.cardShowForm.idCard) {
        this.$message.warning('身份证号不能为空')
        return
      }
      if (!this.cardShowForm.name) {
        this.$message.warning('真实姓名不能为空')
        return
      }
      if (!this.cardShowForm.phone) {
        this.$message.warning('手机号不能为空')
        return
      }
      idCardPhoneApi(this.cardShowForm).then(res => {
        if (res.code === 1) {
          this.$message.success('认证成功')
          this.idCardDialogVisible = false
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    idCardUpDateNoPhone () {
      if (!this.cardShowForm.idCard) {
        this.$message.warning('身份证号不能为空')
        return
      }
      if (!this.cardShowForm.name) {
        this.$message.warning('真实姓名不能为空')
        return
      }
      if (!this.cardShowForm.phone) {
        this.$message.warning('手机号不能为空')
        return
      }
      if (!this.cardShowForm.code) {
        this.$message.warning('验证码不能为空')
        return
      }
      idCardUnPhoneApi(this.cardShowForm).then(res => {
        if (res.code === 1) {
          this.$message.success('认证成功')
          this.idCardDialogVisible = false
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    orderEndPayPriceMeth () {
      if (this.addressList.length !== 0) {
        for (let i = 0; i < this.addressList.length; i++) {
          if (this.addressList[i].name === '' || this.addressList[i].phone === '' || this.addressList[i].address === '') {
            console.log('第' + (i + 1) + '条收件人数据不全')
            return false
          }
        }
      }
      if (!this.dataFlag) {
        console.log('请选择礼品')
        return
      } else if (this.addressList.length === 0) {
        console.log('请至少填写一个收货地址')
        return
      }
      if ([361, 362, 363, 364, 365, 367, 368, 375, 371, 393, 410, 414, 432, 434, 398].indexOf(this.storeListItemId) !== -1) {
        const a = this.addressList
        const postData = {}
        postData.real_list = []
        for (let i = 0; i < a.length; i++) {
          const item = {}
          item.third_order_no = a[i].order
          item.receive_name = a[i].name
          item.receive_phone = a[i].phone
          item.receive_province = a[i].province
          item.receive_city = a[i].city
          item.receive_town = a[i].area
          item.receive_address = a[i].detail
          item.receive_oaid = a[i].oaid
          postData.real_list.push(item)
        }
        postData.goods_id = this.goodsItem.id
        postData.storage_id = this.storeListItemId
        orderEndPayPrice(postData).then(res => {
          if (res.code === 1) {
            console.log(res, 'priceSet')
            this.totalExtraPrice = Number(res.data.totalExtraPrice)
          } else {
            this.$message(res.msg)
          }
        })
      } else {
        this.totalExtraPrice = 0
      }
    },
    // 通过监听子组件发送过来的事件关闭Dialog
    closePayDialog () {
      console.log('mainReload')
      // this.mainReload() // 重置
      // this.$router.push('/orderAdmin/orderList')
    },
    noPathClose (val) {
      console.log(val, 'dialogShow')
      this.dialogShow = false
    },
    toOrderList (val) {
      if (val === 'close') {
        this.mainReload() // 重置/
        this.$router.push('/orderAdmin/orderList')
      } else {
        this.dialogShow = false
      }
      // this.mainReload() // 重置
      // this.$router.push('/orderAdmin/orderList')
    },
    // 停发区域Dialog关闭回调
    closeStopSending () {
      this.showStopSending = false
    },
    // 查看停发
    seeSending () {
      this.showStopSending = true
    },
    // 仓库选择框
    storageSelectChange (e) {
      this.fprice = e.freight_price
    },

    // 发件地址选择框
    areaSelectChange (e) {
      this.area_id = e // 改变发件人地址id
    },
    // 手工填写 ---> 地址格式切换
    handleClick () {
      this.listTableFlag = false
      this.arsObj = {}
      this.addressList = []
    },
    // 随机生成订单编号
    randomNo (j) {
      var randomno = ''
      for (var i = 0; i < j; i++) {
        randomno += Math.floor(Math.random() * 10)
      }
      randomno = new Date().getTime() + randomno
      return randomno
    },
    // 新建地址点击
    mesBox () {
      console.log('aaaaa')
      this.addressDialogShow = true
      // this.$confirm('前往添加发件地址, 是否继续?', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // }).then(() => {
      //   this.$router.push('/orderAdmin/sendAddress')
      // }).catch(() => {})
    },
    closeAddressDialog () {
      this.addressDialogShow = false
    },
    updateAddressDialog () {
      getAreaList().then(res => {
        this.areaList = res.data // 发件人地址列表
        for (let i = 0; i < this.areaList.length; i++) {
          if (this.areaList[i].status === '1') {
            this.areaListValue = this.areaList[i].name + ' ' + this.areaList[i].send_phone // 初始化默认发件人地址
            this.area_id = this.areaList[i].id // 初始化发件人地址id
            this.oid = this.areaList[i].oid //
            return
          }
        }
      })
      this.addressDialogShow = false
    },
    /**
    *
    * 模板导入
    * 自定义上传
    *
    */
    uploadFile (file) {
      this.addressList.length = 0
      const postData = {}
      postData.file = file.file
      postData.platform = this.platform2
      importExcel(postData).then(res => {
        if (res.code === 1) {
          for (let i = 0; i < res.data.length; i++) {
            this.arsObj.name = res.data[i].receive_name
            this.arsObj.phone = res.data[i].receive_phone
            this.arsObj.address = res.data[i].receive_province + res.data[i].receive_city + res.data[i].receive_town + res.data[i].receive_address
            let a
            try {
              a = AddressParse('李达康 ' + this.arsObj.phone + ' ' + this.arsObj.address)
            } catch (error) {
              console.log(error, 'error')
              this.$message.error('第' + (i + 2) + '行地址格式错误，请删除重试')
            }
            // console.log(a, '地址解析')
            this.arsObj.province = a.province
            this.arsObj.city = a.city
            this.arsObj.area = a.area
            this.arsObj.detail = a.detail
            this.arsObj.order = res.data[i].third_order_no
            this.addressList.push(this.arsObj)
            this.arsObj = {}
          }
          this.listTableFlag = true // 显示地址列表
          this.templateImport = false // 上传成功隐藏模板导入
          this.$message({
            message: res.msg,
            type: 'success'
          })
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 设置默认快递
    setDefaultkd () {
      this.$alert('是否将' + this.storeList[this.storeActive].name + '设置为默认快递，设置后将自动选择该快递', '设置默认快递', {
        confirmButtonText: '确定',
        callback: () => {
          setDefaultStorage({ defaultStorageId: this.storeList[this.storeActive].id }).then((res) => {
            if (res.code === 1) {
              this.$message({
                type: 'success',
                message: '默认仓库设置成功'
              })
              this.getDefaultkd(1)
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
    },
    getDefaultkd (type) {
      getDefaultStorage().then(res => {
        if (type === 0) {
          this.stepOneItemClick(0)
        }
        if (res.code === 1) {
          this.userDefaultKd = res.data
        } else {
          this.userDefaultKd = null
        }
      })
    },
    endMailDealWith (res, type) {
      // const deliveryStore = ['韵达','中通','圆通','申通','邮政','顺丰']
      const deliveryStoreId = ['1', '4', '3', '2', '13', '12', '5']
      if (this.userDefaultKd) {
        if (type === 'first') {
          let isDefault = false
          res.data.map((item, index) => {
            if (item.id === this.userDefaultKd.deliver_id) {
              isDefault = true
              const deliveryStore = []
              // const UnDeliveryStoreId = []
              deliveryStoreId.map(item => {
                res.data.map(ite => {
                  if (Number(ite.id) === Number(item)) {
                    deliveryStore.push(ite)
                  }
                })
              })
              this.stepThree = deliveryStore
              this.stepThreeIndex = res.data[index].id
              this.isThird = res.data[index].id
            }
          })
          if (isDefault === false) {
            // this.stepThree = res.data
            const deliveryStore = []
            deliveryStoreId.map(item => {
              res.data.map(ite => {
                if (Number(ite.id) === Number(item)) {
                  deliveryStore.push(ite)
                }
              })
            })
            this.stepThree = deliveryStore
            this.stepThreeIndex = deliveryStore[0].id
            this.isThird = deliveryStore[0].id
          }
          this.stepThreeItemClick(this.stepThreeIndex)
        } else {
          this.storeList = res.data
          this.stopStoreList = res.data
          this.goodsCurrentPage = 1
          if (res.code === 1) {
            let isDefault = false
            res.data.map((item, index) => {
              if (item.id === this.userDefaultKd.id) {
                isDefault = true
                this.storeActive = index
                this.storeListItem = this.storeList[index] // 初始化仓库对象
                this.storeListItemId = this.storeList[index].id
                this.storeListItemName = this.storeList[index].name // 获取到仓库名
              }
            })
            if (isDefault === false) {
              this.storeActive = 0
              this.storeListItem = this.storeList[0] // 初始化仓库对象
              this.storeListItemId = this.storeList[0].id
              this.storeListItemName = this.storeList[0].name // 获取到仓库名
            }
            // 初始化礼品列表
            this.getGoodsSearchGs()
          } else {
            this.goodsList = []
          }
        }
      } else {
        if (type === 'first') {
          // this.stepThree = res.data
          const deliveryStore = []
          deliveryStoreId.map(item => {
            res.data.map(ite => {
              if (Number(ite.id) === Number(item)) {
                deliveryStore.push(ite)
              }
            })
          })
          this.stepThree = deliveryStore
          this.stepThreeIndex = deliveryStore[0].id
          this.isThird = deliveryStore[0].id
          this.stepThreeItemClick(this.stepThreeIndex)
        } else {
          this.storeList = res.data
          this.stopStoreList = res.data
          this.goodsCurrentPage = 1
          if (res.code === 1) {
            this.storeActive = 0
            this.storeListItem = this.storeList[0] // 初始化仓库对象
            this.storeListItemId = this.storeList[0].id
            this.storeListItemName = this.storeList[0].name // 获取到仓库名
            // 初始化礼品列表
            this.getGoodsSearchGs()
          } else {
            this.goodsList = []
          }
        }
      }
    },
    dealWithDataStep (obj) {
      this.stepOneItemClick(Number(obj.platform))
      this.textareaAddressValue = sessionStorage.getItem('address')
      this.addAddressOne()
      this.userDefaultKd = {
        deliver_id: obj.deliverId,
        id: obj.storageId
      }
      goodsSearchGs({
        storage_id: this.storeListItemId,
        goods_type: this.goodsType,
        key: this.$configList[window.location.host]
      }).then(res => {
        res.data.map(item => {
          if (item.id === obj.goodsId) {
            this.addGoods(item)
          }
        })
      })
    },
    sendImageCode () {
      this.number += 1
      this.imgCode = this.$url + '/api/login/getImages?mobile=' + this.cardShowForm.phone + '&event=register' + '?' + this.number
      this.showImgCode = true
      this.$notify({
        message: '请先输入图形验证码',
        type: 'success'
      })
    },
    getCodes () {
      let time = 60
      if (!this.timer) {
        this.timer = setInterval(() => {
          if (time > 0) {
            this.codeFlag = false
            this.codeBtnText = time + 's后重新发送'
            time--
          } else {
            clearInterval(this.timer)
            this.codeFlag = true
            this.codeBtnText = '获取验证码'
            this.timer = null
          }
        }, 1000)
      }
      getCode(this.cardShowForm.phone, 'register', this.cardShowForm.imgCaptcha).then(res => {
        if (res.code === 1) {
          this.$message({
            message: res.msg,
            type: 'success'
          })
          this.showImgCode = false
        } else {
          this.$message({
            message: res.msg,
            type: 'error'
          })
          this.sendImageCode()
        }
      })
    }
  },
  beforeDestroy () {
    if (this.errorOrderTimer !== null) {
      clearInterval(this.errorOrderTimer)
    }
  }
}
</script>

<style scoped src="styles/views/orderAdmin/purchase.css">
</style>
<style scoped>
    .fiexImageWrap{
      width: 280px;
      height: 200px;
      position: fixed;
      right: 20px;
      top: 0;
      bottom: 0;
      margin: auto;
      z-index: 800;
    }
    .fiexImage{
      width: 320px;
      height: 170px;
      position: absolute;
      left: 0;
      top: 0;
    }
    .fiexIcon{
      position: absolute;
      left: 5px;
      top: 5px;
      font-size: 30px;
      z-index: 900;
      cursor: pointer;
    }
    .menuTag {
      width: 45px;
      display: block;
      padding: 0 2px;
      font-size: 11px;
      height: 18px;
      color: #fff !important;
      line-height: 18px;
      border-radius: 4px;
      position: absolute;
      font-style: normal;
      z-index: 100;
      top: -11px;
      left: 85%;
      animation: taganimation 2s linear infinite;
      -webkit-animation: taganimation 2s linear infinite;
      -o-animation: taganimation 2s linear infinite;
      -moz-animation: taganimation 2s linear infinite;
      -ms-animation: taganimation 2s linear infinite;
    }
.menuTag::after{
content: '';
  display: block;
  border: 4px solid transparent;
  border-top-color: inherit;
  border-bottom: none;
  position: absolute;
  top: 100%;
  left: 4px;
}
.hot{
background: #f05555;
border-color: #f05555;
}
.new{
background: #708eff;
border-color: #708eff;
}
@keyframes taganimation {
  0% {
      transform: translateY(0);
  }
  50% {
      transform: translateY(-5px);
  }
  100% {
      transform: translateY(0);
  }
}
</style>
